// Product data and state management
var lxe = {
    woody: {
        name: "WOODY & RESINOUS",
        products: [
            {
                name: "Oud Amber Glow",
                code: "lxe-1008",
                description: "Bulgarian rose, oud, amber",
                notes: {
                    top: ["Bulgarian Rose", "Bergamot"],
                    middle: ["Oud Wood", "Rose Petals"],
                    base: ["Amber", "Sandalwood", "Musk"],
                },
                occasions: [
                    "Evening wear",
                    "Special occasions",
                    "Date nights",
                    "Formal events",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                vid: "https://www.youtube.com/watch?v=example1",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/067b0e2fdb238975d6567015ae713ec0.jpg?v=1756711135"
            },
            {
                name: "Petrichor Vetiver",
                code: "lxe-1011",
                description: "Rain-kissed vetiver & woods",
                notes: {
                    top: ["Wet Earth", "Green Leaves"],
                    middle: ["Vetiver", "Cedarwood"],
                    base: ["Sandalwood", "Moss", "Amber"],
                },
                occasions: [
                    "Casual wear",
                    "Office",
                    "Outdoor activities",
                    "Meditation",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Fall",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/84a7160bb120b094d64514271e5a6c54.jpg?v=1756711135"
            },
            {
                name: "Burnt Rose & Agarwood",
                code: "lxe-1016",
                description: "Saffron incense & oud",
                notes: {
                    top: ["Saffron", "Rose Petals"],
                    middle: ["Agarwood", "Incense"],
                    base: ["Amber", "Sandalwood", "Musk"],
                },
                occasions: [
                    "Evening wear",
                    "Cultural events",
                    "Meditation",
                    "Special ceremonies",
                ],
                longevity: "10-12 hours",
                sillage: "Very Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/9b184766ecb17ab23661259786411b12.jpg?v=1756711135"
            },
            {
                name: "Animalic Agarwood",
                code: "lxe-1031",
                description: "Wild oud & civet amber",
                notes: {
                    top: ["Wild Herbs", "Spices"],
                    middle: ["Agarwood", "Civet"],
                    base: ["Amber", "Animalic Musk", "Leather"],
                },
                occasions: [
                    "Evening wear",
                    "Confidence boost",
                    "Special occasions",
                    "Cold weather",
                ],
                longevity: "12+ hours",
                sillage: "Very Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/815fcdb2b4d4b4128ab517b630940989.jpg?v=1756807854"
            },
            {
                name: "Warm Spicy Aura",
                code: "lxe-1038",
                description: "Cardamom, violet, patchouli",
                notes: {
                    top: ["Cardamom", "Pink Pepper"],
                    middle: ["Violet", "Rose"],
                    base: ["Patchouli", "Sandalwood", "Amber"],
                },
                occasions: [
                    "Evening wear",
                    "Date nights",
                    "Cooler weather",
                    "Artistic events",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/111b6360357314803b93a8b43accafe5.jpg?v=1756711135"
            },
            {
                name: "Burnt Sugar & Amber",
                code: "lxe-1022",
                description: "Saffron sugar, sandal, ambergris",
                notes: {
                    top: ["Saffron", "Caramelized Sugar"],
                    middle: ["Sandalwood", "Rose"],
                    base: ["Ambergris", "Vanilla", "Musk"],
                },
                occasions: [
                    "Evening wear",
                    "Romantic dinners",
                    "Special occasions",
                    "Cold weather",
                ],
                longevity: "10-12 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/8655d3e919a25137ce161e327046646d.jpg?v=1756711135"
            },
        ],
    },
    sweet: {
        name: "GOURMAND & SWEET",
        products: [
            {
                name: "Burnt Vanilla Sugarcane",
                code: "lxe-1009",
                description: "Burnt sugar, vanilla, tobacco",
                notes: {
                    top: ["Burnt Sugar", "Caramel"],
                    middle: ["Madagascar Vanilla", "Tobacco Leaf"],
                    base: ["Amber", "Sandalwood", "Musk"],
                },
                occasions: [
                    "Evening wear",
                    "Date nights",
                    "Cozy gatherings",
                    "Cold weather",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/bedf0b3ba60a595a4f084fd5c94a5442.jpg?v=1756711136"
            },
            {
                name: "Burnt Vanilla & Coffee",
                code: "lxe-1030",
                description: "Warm vanilla, deep musk, coffee",
                notes: {
                    top: ["Coffee Bean", "Cardamom"],
                    middle: ["Vanilla", "Caramel"],
                    base: ["Deep Musk", "Sandalwood", "Amber"],
                },
                occasions: [
                    "Morning wear",
                    "Office",
                    "Casual outings",
                    "Coffee dates",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/b860f8da5c8c8a92a0180cc07c2f24c8.jpg?v=1756711135"
            },
            {
                name: "Mango Almond Silk",
                code: "lxe-1018",
                description: "Almond cream, mango, sandalwood",
                notes: {
                    top: ["Mango", "Bergamot"],
                    middle: ["Almond Cream", "Coconut"],
                    base: ["Sandalwood", "Vanilla", "White Musk"],
                },
                occasions: [
                    "Summer evenings",
                    "Tropical vacations",
                    "Romantic dinners",
                    "Special occasions",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/6f558209bca8c009629e9ebb40fa8633.jpg?v=1756711135"
            },
            {
                name: "Sweet Fresh Champagne",
                code: "lxe-1035",
                description: "Quince, freesia, almond musk",
                notes: {
                    top: ["Quince", "Pear", "Sparkling Notes"],
                    middle: ["Freesia", "Lily of the Valley"],
                    base: ["Almond Musk", "Vanilla", "Sandalwood"],
                },
                occasions: [
                    "Celebrations",
                    "Daytime events",
                    "Spring outings",
                    "Brunch dates",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/48200636f966493b835b3e3f3bf7bd64.jpg?v=1756711136"
            },
            {
                name: "Sweet Citrus Glow",
                code: "lxe-1037",
                description: "Tangerine, green apple, vanilla",
                notes: {
                    top: ["Tangerine", "Green Apple", "Lemon"],
                    middle: ["Orange Blossom", "Peach"],
                    base: ["Vanilla", "White Musk", "Cedarwood"],
                },
                occasions: [
                    "Daytime wear",
                    "Casual outings",
                    "Work",
                    "Spring activities",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/584f9d1204cbb93779eeadcc1f51c84f.jpg?v=1756711136"
            },
            {
                name: "Green Vanilla Veil",
                code: "lxe-1036",
                description: "Lemon, mint, tonka, Madagascar vanilla",
                notes: {
                    top: ["Lemon", "Mint", "Green Leaves"],
                    middle: ["Tonka Bean", "Coconut"],
                    base: ["Madagascar Vanilla", "Sandalwood", "Musk"],
                },
                occasions: [
                    "Daytime wear",
                    "Spring outings",
                    "Casual events",
                    "Fresh starts",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/0036e24b3412ba80e3e24cc3020a1bab.jpg?v=1756711135"
            },
        ],
    },
    fresh: {
        name: "FRESH & FLORAL",
        products: [
            {
                name: "Sandal Green Amber",
                code: "lxe-1012",
                description: "Green citrus, sandal, cedar",
                notes: {
                    top: ["Green Citrus", "Bergamot", "Lime"],
                    middle: ["Sandalwood", "Geranium"],
                    base: ["Cedar", "Amber", "White Musk"],
                },
                occasions: [
                    "Daytime wear",
                    "Office",
                    "Casual outings",
                    "Spring activities",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fa8115a116bd1d72193cb6d7d0de9404.jpg?v=1756711136"
            },
            {
                name: "Citrus & Warm Spice",
                code: "lxe-1014",
                description: "Cinnamon, nutmeg, lavender woods",
                notes: {
                    top: ["Cinnamon", "Nutmeg", "Orange"],
                    middle: ["Lavender", "Geranium"],
                    base: ["Sandalwood", "Cedar", "Amber"],
                },
                occasions: [
                    "Daytime wear",
                    "Autumn walks",
                    "Cozy gatherings",
                    "Weekend activities",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Fall/Spring",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/2120186066c813757ae4661e6a763e48.jpg?v=1756807853"
            },
            {
                name: "Sea Salt & Tobacco",
                code: "lxe-1032",
                description: "Marine air, orchid, incense",
                notes: {
                    top: ["Sea Salt", "Marine Air", "Ozone"],
                    middle: ["Orchid", "Tobacco Leaf"],
                    base: ["Incense", "Driftwood", "Amber"],
                },
                occasions: [
                    "Evening wear",
                    "Meditation",
                    "Coastal walks",
                    "Artistic events",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/dfcf26d5444e1900486f42e7a948b537.jpg?v=1756711136"
            },
        ],
    },
};
var healingNotes = {
    "healing-note": {
        name: "Healing Notes",
        products: [
            {
                name: "Mullai",
                code: "mullai",
                description: "Sweet floral",
                benefit: "REDUCE STRESS",
                notes: {
                    top: ["Sweet Jasmine", "White Flowers"],
                    middle: ["Mullai Blossoms", "Green Leaves"],
                    base: ["Soft Musk", "Woody Notes"]
                },
                occasions: ["Meditation", "Relaxation", "Evening wear", "Self-care"],
                longevity: "4-6 hours",
                sillage: "Soft",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/mullai.webp?v=1759753704"
            },
            {
                name: "Thazhampoo",
                code: "thazhampoo",
                description: "Spicy floral",
                benefit: "GOOD FOR SPIRITUALITY",
                notes: {
                    top: ["Spiced Florals", "Clove"],
                    middle: ["Magnolia", "Temple Flowers"],
                    base: ["Incense", "Sandalwood", "Amber"]
                },
                occasions: ["Meditation", "Prayer", "Spiritual practices", "Temple visits"],
                longevity: "5-7 hours",
                sillage: "Moderate",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Thazhampoo.jpg?v=1759753705"
            },
            {
                name: "Pitchipoo",
                code: "pitchipoo",
                description: "Floral & musky",
                benefit: "ENERGIZES THE MOOD",
                notes: {
                    top: ["Fresh Florals", "Citrus"],
                    middle: ["Jasmine", "White Flowers"],
                    base: ["Musk", "Amber", "Soft Woods"]
                },
                occasions: ["Morning wear", "Work", "Active days", "Social gatherings"],
                longevity: "4-6 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Pitchipoo.webp?v=1759753704"
            },
            {
                name: "Marikolundhu",
                code: "marikolundhu",
                description: "Citrus & floral",
                benefit: "IMPROVES SLEEP",
                notes: {
                    top: ["Bergamot", "Lemon", "Orange Blossom"],
                    middle: ["Lavender", "Chamomile"],
                    base: ["Soft Musk", "Vanilla", "Sandalwood"]
                },
                occasions: ["Bedtime", "Evening relaxation", "Stress relief", "Home wear"],
                longevity: "4-6 hours",
                sillage: "Soft",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Marikolundhu_0b114d36-1505-49ab-8f43-aeffd59e12f0.png?v=1759753706"
            },
            {
                name: "Mogra",
                code: "mogra",
                description: "Green floral",
                benefit: "CALMS THE MIND",
                notes: {
                    top: ["Green Leaves", "Fresh Jasmine"],
                    middle: ["Mogra Flowers", "White Florals"],
                    base: ["Soft Musk", "Cedarwood"]
                },
                occasions: ["Meditation", "Yoga", "Evening wear", "Relaxation"],
                longevity: "5-7 hours",
                sillage: "Soft to Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Mogra.jpg?v=1759753704"
            },
            {
                name: "Sampangi",
                code: "sampangi",
                description: "Fruity & floral",
                benefit: "REDUCE TENSION",
                notes: {
                    top: ["Peach", "Apricot", "Citrus"],
                    middle: ["Champaca", "Orange Blossom"],
                    base: ["Sandalwood", "Musk", "Vanilla"]
                },
                occasions: ["Daytime wear", "Stress relief", "Social events", "Casual outings"],
                longevity: "5-7 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Sampangi.jpg?v=1759753703"
            },
            {
                name: "Tube Rose",
                code: "tube rose",
                description: "Earthy floral",
                benefit: "AIDS SLEEP",
                notes: {
                    top: ["Green Notes", "Bergamot"],
                    middle: ["Tuberose", "Jasmine"],
                    base: ["Earthy Musk", "Sandalwood", "Amber"]
                },
                occasions: ["Bedtime", "Evening relaxation", "Meditation", "Calm moments"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Tube_Rose.jpg?v=1759753704"
            },
            {
                name: "Night Queen",
                code: "night queen",
                description: "Floral sweet",
                benefit: "ANXIETY RELIEVER",
                notes: {
                    top: ["Sweet Florals", "Honeysuckle"],
                    middle: ["Night Blooming Jasmine", "Gardenia"],
                    base: ["Vanilla", "Musk", "Amber"]
                },
                occasions: ["Evening wear", "Stress relief", "Romantic evenings", "Relaxation"],
                longevity: "5-7 hours",
                sillage: "Moderate",
                season: "Summer/Fall",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Night_Queen.jpg?v=1759753704"
            },
            {
                name: "Ylang Ylang",
                code: "ylang ylang",
                description: "Fruity & spice",
                benefit: "AIDS SLEEP",
                notes: {
                    top: ["Banana", "Neroli", "Bergamot"],
                    middle: ["Ylang Ylang", "Jasmine", "Spices"],
                    base: ["Vanilla", "Sandalwood", "Musk"]
                },
                occasions: ["Bedtime", "Meditation", "Evening wear", "Spa days"],
                longevity: "6-8 hours",
                sillage: "Moderate to Strong",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Ylang_Ylang.jpg?v=1759753704"
            },
            {
                name: "Pahadi",
                code: "pahadi",
                description: "Floral & earthy",
                benefit: "CALMING",
                notes: {
                    top: ["Mountain Flowers", "Fresh Air"],
                    middle: ["Wild Herbs", "Lavender"],
                    base: ["Earth", "Moss", "Cedarwood"]
                },
                occasions: ["Meditation", "Yoga", "Nature walks", "Stress relief"],
                longevity: "4-6 hours",
                sillage: "Soft",
                season: "Spring/Fall",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Pahadi.jpg?v=1759753703"
            },
            {
                name: "Rajinigantha",
                code: "rajinigantha",
                description: "Floral & vetiver",
                benefit: "RELAXATION",
                notes: {
                    top: ["White Flowers", "Green Leaves"],
                    middle: ["Tuberose", "Jasmine"],
                    base: ["Vetiver", "Sandalwood", "Musk"]
                },
                occasions: ["Evening wear", "Meditation", "Stress relief", "Calm moments"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Rajinigantha.jpg?v=1759753704"
            },
            {
                name: "Rose",
                code: "rose",
                description: "Floral & warm spice",
                benefit: "IMPROVES BRAIN HEALTH",
                notes: {
                    top: ["Rose Petals", "Bergamot"],
                    middle: ["Bulgarian Rose", "Geranium", "Cinnamon"],
                    base: ["Amber", "Sandalwood", "Musk"]
                },
                occasions: ["Daytime wear", "Focus work", "Study sessions", "All occasions"],
                longevity: "5-7 hours",
                sillage: "Moderate",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/rose.jpg?v=1759753704"
            }
        ]
    }
};

var divineNotes = {
    "divine-note": {
        name: "Divine Notes",
        products: [
            {
                name: "Jawwad",
                code: "jawwad",
                description: "Civet & amber",
                notes: {
                    top: ["Saffron", "Rose"],
                    middle: ["Civet", "Amber"],
                    base: ["Benzoin", "Musk", "Agarwood"]
                },
                occasions: ["Special occasions", "Evening wear", "Cultural events", "Celebrations"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Jawwad.jpg?v=1759753725"
            },
            {
                name: "Jawwad Amrut",
                code: "jawwad amrut",
                description: "Civet, amber & honey",
                notes: {
                    top: ["Honey", "Nutmeg", "Saffron"],
                    middle: ["Civet", "Patchouli", "Rose"],
                    base: ["Amber", "Labdanum", "Benzoin"]
                },
                occasions: ["Special occasions", "Evening wear", "Weddings", "Formal events"],
                longevity: "10-12 hours",
                sillage: "Very Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Amrut.jpg?v=1759753724"
            },
            {
                name: "Majmua",
                code: "majmua",
                description: "Rose, amber & wood",
                notes: {
                    top: ["Saffron", "White Rose", "Bergamot"],
                    middle: ["Amber", "Bulgarian Rose", "Patchouli"],
                    base: ["Sandalwood", "Mixed Woods", "Vetiver"]
                },
                occasions: ["Special occasions", "Prayer", "Cultural events", "Evening wear"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/067b0e2fdb238975d6567015ae713ec0.jpg?v=1756711135"
            },
            {
                name: "Jannat Ul Firdaus",
                code: "jannat ul firdaus",
                description: "Rose, herbal & spice",
                notes: {
                    top: ["Herbal Notes", "Grass", "Citrus"],
                    middle: ["Rose", "Cinnamon", "Lotus", "Tea"],
                    base: ["Woody Notes", "Jasmine", "Musk"]
                },
                occasions: ["Special occasions", "Prayer", "Spiritual events", "Evening wear"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Jannat_Ul_Firdaus.jpg?v=1759753723"
            }
        ]
    }
};


var ffData = {
    oriental: {
        name: "✨ Oriental",
        subcategories: {
            "deep-smoky": {
                name: "Deep & Smoky",
                products: [
                    {
                        name: "Dark Tobacco Essence",
                        code: "oriental-107",
                        description: "Dark tobacco, leather, amber",
                        notes: {
                            top: ["Black Pepper", "Bergamot"],
                            middle: ["Dark Tobacco", "Leather"],
                            base: ["Amber", "Sandalwood", "Musk"],
                        },
                        occasions: [
                            "Evening wear",
                            "Business meetings",
                            "Cold weather",
                            "Formal events",
                        ],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/16c856b316b44f7c630e0879f7f5f220.jpg?v=1756711777",
                        link: "https://wanaromah.com/products/oriental-107",
                    },
                    {
                        name: "Smoky Oud Mystery",
                        code: "oriental-110",
                        description: "Smoky oud, incense, vanilla",
                        notes: {
                            top: ["Incense", "Saffron"],
                            middle: ["Smoky Oud", "Rose"],
                            base: ["Vanilla", "Amber", "Sandalwood"],
                        },
                        occasions: [
                            "Evening wear",
                            "Meditation",
                            "Special occasions",
                            "Cultural events",
                        ],
                        longevity: "10-12 hours",
                        sillage: "Very Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/05d0d1ba3e1df524644df3c06a249d84.jpg?v=1756711777",
                        link: "https://wanaromah.com/products/oriental-110",
                    },
                    {
                        name: "Leather & Smoke",
                        code: "oriental-116",
                        description: "Leather, smoke, dark woods",
                        notes: {
                            top: ["Smoke", "Black Pepper"],
                            middle: ["Leather", "Dark Woods"],
                            base: ["Sandalwood", "Amber", "Musk"],
                        },
                        occasions: [
                            "Evening wear",
                            "Business meetings",
                            "Formal events",
                            "Winter wear",
                        ],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/af2ba6e737f5a50b50bd8f5ad485ed0c.jpg?v=1756711777",
                        link: "https://wanaromah.com/products/oriental-116",
                    },
                ],
            },
            "resinous-rich": {
                name: "Resinous & Rich",
                products: [
                    {
                        name: "Frankincense Dreams",
                        code: "oriental-099",
                        description: "Frankincense, myrrh, sandalwood",
                        notes: {
                            top: ["Frankincense", "Bergamot"],
                            middle: ["Myrrh", "Rose"],
                            base: ["Sandalwood", "Amber", "Musk"],
                        },
                        occasions: [
                            "Meditation",
                            "Evening wear",
                            "Spiritual events",
                            "Cold weather",
                        ],
                        longevity: "10-12 hours",
                        sillage: "Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/a076331b4f164006901184c6ed2c1912.jpg?v=1756711778",
                        link: "https://wanaromah.com/products/oriental-099",
                    },
                    {
                        name: "Amber Resin Glow",
                        code: "oriental-101",
                        description: "Amber resin, benzoin, vanilla",
                        notes: {
                            top: ["Bergamot", "Orange"],
                            middle: ["Amber Resin", "Benzoin"],
                            base: ["Vanilla", "Sandalwood", "Musk"],
                        },
                        occasions: [
                            "Evening wear",
                            "Date nights",
                            "Cozy gatherings",
                            "Cold weather",
                        ],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/7d06fae0a44c69522d28f8864f5edbbc.jpg?v=1756711778",
                        link: "https://wanaromah.com/products/oriental-101",
                    },
                    {
                        name: "Rich Oud Blend",
                        code: "oriental-111",
                        description: "Rich oud, amber, spices",
                        notes: {
                            top: ["Saffron", "Cardamom"],
                            middle: ["Rich Oud", "Rose"],
                            base: ["Amber", "Sandalwood", "Musk"],
                        },
                        occasions: [
                            "Special occasions",
                            "Evening wear",
                            "Celebrations",
                            "Formal events",
                        ],
                        longevity: "12+ hours",
                        sillage: "Very Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/95af9f0fc9dde2ec00c662b37ba4bef4.jpg?v=1756711778",
                        link: "https://wanaromah.com/products/oriental-111",
                    },
                    {
                        name: "Oriental Mystique",
                        code: "oriental-105",
                        description: "Oriental spices, amber, sandalwood",
                        notes: {
                            top: ["Cardamom", "Cinnamon"],
                            middle: ["Oriental Spices", "Amber"],
                            base: ["Sandalwood", "Musk", "Vanilla"],
                        },
                        occasions: [
                            "Evening wear",
                            "Cultural events",
                            "Special occasions",
                            "Cold weather",
                        ],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/2c7685114d4a7770e9a2b2545526703a.jpg?v=1756711778",
                        link: "https://wanaromah.com/products/oriental-105",
                    },
                    {
                        name: "Oriental Harmony",
                        code: "oriental-112",
                        description: "Balanced oriental blend, amber, woods",
                        notes: {
                            top: ["Bergamot", "Spices"],
                            middle: ["Oriental Blend", "Amber"],
                            base: ["Woods", "Sandalwood", "Musk"],
                        },
                        occasions: [
                            "All occasions",
                            "Business",
                            "Evening wear",
                            "Formal events",
                        ],
                        longevity: "8-10 hours",
                        sillage: "Moderate to Strong",
                        season: "All seasons",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/d017d548dbec0adfaa05e8d164ca1c65.jpg?v=1756711777",
                        link: "https://wanaromah.com/products/oriental-112",
                    },
                    {
                        name: "Oriental Luxury",
                        code: "oriental-115",
                        description:
                            "Luxury oriental spices, gold amber, precious woods",
                        notes: {
                            top: ["Saffron", "Cardamom"],
                            middle: ["Luxury Spices", "Gold Amber"],
                            base: ["Precious Woods", "Oud", "Musk"],
                        },
                        occasions: [
                            "Luxury events",
                            "Special occasions",
                            "VIP gatherings",
                            "Formal ceremonies",
                        ],
                        longevity: "10-12 hours",
                        sillage: "Very Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/303e3cf402f15fdbea3aa23724dbc1a7.jpg?v=1756711777",
                        link: "https://wanaromah.com/products/oriental-115",
                    },
                ],
            },
            "soft-oud": {
                name: "Soft Oud & Floral",
                products: [
                    {
                        name: "Rose Oud Harmony",
                        code: "oriental-108",
                        description: "Rose, oud, jasmine",
                        notes: {
                            top: ["Rose", "Bergamot"],
                            middle: ["Oud", "Jasmine"],
                            base: ["Sandalwood", "Amber", "Musk"],
                        },
                        occasions: [
                            "Evening wear",
                            "Date nights",
                            "Romantic dinners",
                            "Special occasions",
                        ],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "All seasons",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/888b25797840e649143cfa8969359e0e.jpg?v=1756711778",
                        link: "https://wanaromah.com/products/oriental-108",
                    },
                    {
                        name: "Jasmine Oud Dream",
                        code: "oriental-113",
                        description: "Jasmine, oud, sandalwood",
                        notes: {
                            top: ["Jasmine", "Bergamot"],
                            middle: ["Oud", "Rose"],
                            base: ["Sandalwood", "Amber", "Musk"],
                        },
                        occasions: [
                            "Evening wear",
                            "Romantic occasions",
                            "Cultural events",
                            "Special dinners",
                        ],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Spring/Fall",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/4ff1da6570a15c78a554d2462b676f85.jpg?v=1756711778",
                        link: "https://wanaromah.com/products/oriental-113",
                    },
                ],
            },
            "tobacco-amber": {
                name: "Tobacco & Amber",
                products: [
                    {
                        name: "Vanilla Tobacco Dream",
                        code: "oriental-109",
                        description: "Vanilla tobacco, warm amber",
                        notes: {
                            top: ["Bergamot", "Spices"],
                            middle: ["Vanilla Tobacco", "Honey"],
                            base: ["Warm Amber", "Sandalwood", "Musk"],
                        },
                        occasions: [
                            "Evening wear",
                            "Cozy gatherings",
                            "Date nights",
                            "Cold weather",
                        ],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/03eea0ea321794d3011881bff3d94d1b.jpg?v=1756711778",
                        link: "https://wanaromah.com/products/oriental-109",
                    },
                    {
                        name: "Amber Tobacco Blend",
                        code: "oriental-114",
                        description: "Amber, tobacco leaf, honey",
                        notes: {
                            top: ["Honey", "Bergamot"],
                            middle: ["Tobacco Leaf", "Spices"],
                            base: ["Amber", "Sandalwood", "Vanilla"],
                        },
                        occasions: [
                            "Evening wear",
                            "Autumn activities",
                            "Cozy settings",
                            "Special occasions",
                        ],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/1f3b3a5a5ebfd7bfb5297102a9a47b6f.jpg?v=1756711777",
                        link: "https://wanaromah.com/products/oriental-114",
                    },
                ],
            },
        },
    },
    floral: {
        name: "Floral",
        subcategories: {
            "rose-forward": {
                name: "Rose-Forward",
                products: [
                    {
                        name: "Rose Garden Romance",
                        code: "floral-159",
                        description: "Red rose, peony, rose water",
                        notes: {
                            top: ["Rose Water", "Bergamot"],
                            middle: ["Red Rose", "Peony"],
                            base: ["Sandalwood", "Musk", "Amber"],
                        },
                        occasions: [
                            "Date nights",
                            "Romantic dinners",
                            "Spring events",
                            "Wedding occasions",
                        ],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/8cf0f2b7a46ea55ec76f15ec443666e2.jpg?v=1756714910",
                        link: "https://wanaromah.com/products/floral-159",
                    },
                    {
                        name: "Bulgarian Rose Essence",
                        code: "floral-170",
                        description: "Bulgarian rose, damask rose, musk",
                        notes: {
                            top: ["Bulgarian Rose", "Lemon"],
                            middle: ["Damask Rose", "Geranium"],
                            base: ["White Musk", "Sandalwood", "Amber"],
                        },
                        occasions: [
                            "Special occasions",
                            "Evening wear",
                            "Formal events",
                            "Romantic settings",
                        ],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "All seasons",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/8e47d0bd73dafa1d339cb2b2b13c2b7e.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/floral-188",
                    },
                    {
                        name: "Rose Petals Dream",
                        code: "floral-166",
                        description: "Rose petals, vanilla, sandalwood",
                        notes: {
                            top: ["Rose Petals", "Bergamot"],
                            middle: ["Rose", "Jasmine"],
                            base: ["Vanilla", "Sandalwood", "Musk"],
                        },
                        occasions: [
                            "Evening wear",
                            "Cozy gatherings",
                            "Date nights",
                            "Self-care moments",
                        ],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fdb4a770776a2cdbd74847f412764ae7.jpg?v=1756714910",
                        link: "https://wanaromah.com/products/floral-191",
                    },
                ],
            },
            "white-florals": {
                name: "White Florals & Tuberose",
                products: [
                    {
                        name: "White Floral Bouquet",
                        code: "floral-154",
                        description: "Tuberose, gardenia, lily",
                        notes: {
                            top: ["Lily", "Bergamot"],
                            middle: ["Tuberose", "Gardenia"],
                            base: ["Sandalwood", "Musk", "Amber"],
                        },
                        occasions: [
                            "Evening wear",
                            "Special occasions",
                            "Formal events",
                            "Wedding celebrations",
                        ],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/80f4728c79eb197fb265d1ad810bf8f7.jpg?v=1756714910",
                        link: "https://wanaromah.com/products/floral-154",
                    },
                    {
                        name: "Tuberose Night",
                        code: "floral-163",
                        description: "Tuberose, jasmine, white musk",
                        notes: {
                            top: ["Tuberose", "Bergamot"],
                            middle: ["Jasmine", "White Florals"],
                            base: ["White Musk", "Sandalwood", "Amber"],
                        },
                        occasions: [
                            "Evening wear",
                            "Date nights",
                            "Romantic occasions",
                            "Night events",
                        ],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/4125fbadf2a65c4158c460d8bc567646.jpg?v=1756807854",
                        link: "https://wanaromah.com/products/floral-194",
                    },
                    {
                        name: "Gardenia Dreams",
                        code: "floral-165",
                        description: "Gardenia, magnolia, cream",
                        notes: {
                            top: ["Gardenia", "Bergamot"],
                            middle: ["Magnolia", "White Florals"],
                            base: ["Cream", "Sandalwood", "Musk"],
                        },
                        occasions: [
                            "Daytime wear",
                            "Spring events",
                            "Romantic settings",
                            "Garden parties",
                        ],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/6b37a6814550576bdf4eac3d7e64cb85.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/floral-165",
                    },
                ],
            },
            "fruity-florals": {
                name: "Fruity Florals",
                products: [
                    {
                        name: "Peach Blossom Joy",
                        code: "floral-161",
                        description: "Peach blossom, cherry, magnolia",
                        notes: {
                            top: ["Peach Blossom", "Bergamot"],
                            middle: ["Cherry", "Magnolia"],
                            base: ["Sandalwood", "Musk", "Vanilla"],
                        },
                        occasions: [
                            "Daytime wear",
                            "Spring events",
                            "Casual outings",
                            "Cheerful moments",
                        ],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/e50f16274de41d49a5ecf9659a57eb57.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/floral-161",
                    },
                    {
                        name: "Fruity Floral Fusion",
                        code: "floral-164",
                        description: "Pear, freesia, white florals",
                        notes: {
                            top: ["Pear", "Bergamot"],
                            middle: ["Freesia", "White Florals"],
                            base: ["White Musk", "Sandalwood", "Amber"],
                        },
                        occasions: [
                            "Daytime wear",
                            "Office",
                            "Casual elegance",
                            "Spring activities",
                        ],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/891bf04e632aea9a9c356ed640dee81c.jpg?v=1756807855",
                        link: "https://wanaromah.com/products/floral-193",
                    },
                    {
                        name: "Berry Blossom",
                        code: "floral-168",
                        description: "Berry, cherry blossom, musk",
                        notes: {
                            top: ["Berry", "Bergamot"],
                            middle: ["Cherry Blossom", "Florals"],
                            base: ["Clean Musk", "Sandalwood", "Vanilla"],
                        },
                        occasions: [
                            "Daytime wear",
                            "Casual outings",
                            "Spring events",
                            "Youthful moments",
                        ],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/f34ce2ecfd6605a86cafce001d8ed2f2.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/floral-189",
                    },
                ],
            },
            "oceanic-green": {
                name: "Oceanic or Green Florals",
                products: [
                    {
                        name: "Oceanic Floral Breeze",
                        code: "floral-158",
                        description: "Sea lily, salt air, driftwood",
                        notes: {
                            top: ["Sea Lily", "Salt Air"],
                            middle: ["Marine Florals", "Seaweed"],
                            base: ["Driftwood", "Musk", "Amber"],
                        },
                        occasions: [
                            "Daytime wear",
                            "Beach activities",
                            "Summer events",
                            "Fresh moments",
                        ],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/3ed3ef537a35c52e5c6ac8208822783b.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/floral-158",
                    },
                    {
                        name: "Green Floral Garden",
                        code: "floral-160",
                        description: "Green florals, ivy, sea breeze",
                        notes: {
                            top: ["Green Florals", "Sea Breeze"],
                            middle: ["Ivy", "Garden Flowers"],
                            base: ["Green Musk", "Sandalwood", "Amber"],
                        },
                        occasions: [
                            "Daytime wear",
                            "Garden parties",
                            "Fresh moments",
                            "Nature walks",
                        ],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/5f8780c20eff5ac8a3c5d4e769ca9bbe.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/floral-160",
                    }

                ],
            },
            "additional-florals": {
                name: "Additional Florals",
                products: [
                    {
                        name: "Floral Elegance",
                        code: "floral-157",
                        description: "Mixed florals, elegance, sophistication",
                        notes: {
                            top: ["Mixed Florals", "Bergamot"],
                            middle: ["Rose", "Jasmine"],
                            base: ["Sandalwood", "Musk", "Amber"],
                        },
                        occasions: [
                            "All occasions",
                            "Office",
                            "Evening wear",
                            "Formal events",
                        ],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "All seasons",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/c78ef2a9cc8afdd559c8e15aa43c3943.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/floral-157",
                    },
                    {
                        name: "Floral Symphony",
                        code: "floral-162",
                        description: "Harmonious floral blend, symphony of flowers",
                        notes: {
                            top: ["Floral Blend", "Bergamot"],
                            middle: ["Rose", "Jasmine", "Lily"],
                            base: ["Sandalwood", "Musk", "Amber"],
                        },
                        occasions: [
                            "Special occasions",
                            "Evening wear",
                            "Formal events",
                            "Celebrations",
                        ],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "All seasons",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/6da38171e3a6e6419c46400484f68c78.jpg?v=1756714910",
                        link: "https://wanaromah.com/products/floral-195",
                    },
                    {
                        name: "Floral Whisper",
                        code: "floral-167",
                        description: "Soft florals, whisper, delicate",
                        notes: {
                            top: ["Soft Florals", "Bergamot"],
                            middle: ["Delicate Rose", "Jasmine"],
                            base: ["White Musk", "Sandalwood", "Amber"],
                        },
                        occasions: [
                            "Daytime wear",
                            "Office",
                            "Intimate moments",
                            "Subtle elegance",
                        ],
                        longevity: "6-8 hours",
                        sillage: "Light to Moderate",
                        season: "All seasons",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/3581fb84acec0a0451cc66b1defe9acf.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/floral-190",
                    },
                    {
                        name: "Floral Mystique",
                        code: "floral-169",
                        description: "Mysterious florals, mystique, enchanting",
                        notes: {
                            top: ["Mysterious Florals", "Bergamot"],
                            middle: ["Enchanting Flowers", "Spices"],
                            base: ["Sandalwood", "Musk", "Amber"],
                        },
                        occasions: [
                            "Evening wear",
                            "Special occasions",
                            "Mysterious moments",
                            "Enchanting events",
                        ],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "All seasons",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/42f77282d2a94484c8a6272075ccbfc8.jpg?v=1756714910",
                        link: "https://wanaromah.com/products/floral-171",
                    },
                ],
            },
        },
    },
    sweet: {
        name: "✨ Sweet",
        subcategories: {
            "fruity-playful": {
                name: "Fruity & Playful",
                products: [
                    {
                        name: "Raspberry Floral Charm",
                        code: "sweet-136",
                        description: "Juicy raspberry and floral tones with honey",
                        notes: {
                            top: ["Raspberry", "Neroli", "Amalfi Lemon"],
                            middle: ["Jasmine", "Gardenia"],
                            base: ["White Honey", "Patchouli", "Amber"],
                        },
                        occasions: ["Special Occasion"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-136_fbb17a80-fda1-490b-8be5-a663b28af887.jpg?v=1758281195",
                        link: "https://wanaromah.com/products/sweet-136",
                    },

                    {
                        name: "Fruity Playful Mix",
                        code: "sweet-137",
                        description: "Strawberry, peach, vanilla",
                        notes: {
                            top: ["Pear", "Red Berries"],
                            middle: ["Gardenia", "Frangipani"],
                            base: ["Patchouli", "Musk"],
                        },
                        occasions: ["Casual"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/e4896babf6d661083d25dc7ac1a8b13d.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/sweet-137",
                    },
                    {
                        name: "Tropical Berry Coconut",
                        code: "sweet-138",
                        description: "Exotic blend of berries, coconut, and florals",
                        notes: {
                            top: ["Mango", "Blood Orange"],
                            middle: ["Raspberry", "Star Apple", "Water Lily"],
                            base: ["Musk", "Coconut", "Sandalwood"],
                        },
                        occasions: ["All"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-138_649eaba9-46c5-498b-8cce-19a7d08d3b16.jpg?v=1758281085",
                        link: "https://wanaromah.com/products/sweet-138",
                    },

                    {
                        name: "Berry Burst Joy",
                        code: "sweet-139",
                        description: "Mixed berries, sugar, musk",
                        notes: {
                            top: ["Amalfi Lemon", "Mandarin Orange"],
                            middle: ["Nagarmotha", "Sea Notes"],
                            base: ["Amber", "Patchouli"],
                        },
                        occasions: ["Formal"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/51c814671a6fad5176cc222906dbde71.jpg?v=1756714910",
                        link: "https://wanaromah.com/products/sweet-139",
                    }, {
                        name: "Citrus Floral Essence",
                        code: "sweet-142",
                        description: "Zesty citrus blended with elegant florals",
                        notes: {
                            top: ["Lime", "Bergamot", "Blackcurrant", "Plum"],
                            middle: ["Iris", "Rose", "Jasmine"],
                            base: ["Musk", "Ambergris", "Cedar", "Sandalwood"],
                        },
                        occasions: ["Formal"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-142_f8409df6-0c0e-4e31-abc2-dec636a4b765.jpg?v=1758281085",
                        link: "https://wanaromah.com/products/sweet-142",
                    }
                    , {
                        name: "Citrus Blossom Joy",
                        code: "sweet-145",
                        description: "Bright mandarin and florals with a woody base",
                        notes: {
                            top: ["Mandarin Orange", "Bergamot"],
                            middle: ["Jasmine"],
                            base: ["Cypress", "Pine", "Laurels"],
                        },
                        occasions: ["Sports"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-145_9081dfa0-0eaa-48a2-8e26-cda1fc18cd4a.jpg?v=1758281085",
                        link: "https://wanaromah.com/products/sweet-145",
                    },

                    {
                        name: "Tropical Fruit Dream",
                        code: "sweet-146",
                        description: "Mango, pineapple, coconut",
                        notes: {
                            top: ["Saffron", "Raspberry", "Pineapple"],
                            middle: ["Rose", "Davana"],
                            base: ["Agarwood", "Nagarmotha", "Amber"],
                        },
                        occasions: ["Special Occasion"],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fd887a934c35fe6efcb899a23823c08b.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/sweet-146",
                    },
                    {
                        name: "Berry Peony Glow",
                        code: "sweet-148",
                        description: "Vibrant berries blended with peony and florals",
                        notes: {
                            top: ["Passion Fruit", "Grapefruit", "Pineapple", "Strawberry"],
                            middle: ["Peony", "Vanilla Orchid", "Red Berries", "Lily of the Valley"],
                            base: ["Musk", "Cedarwood", "Oakmoss"],
                        },
                        occasions: ["Casual"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-148_a9481709-2ce1-4c30-adb3-73a11293348a.jpg?v=1758281086",
                        link: "https://wanaromah.com/products/sweet-148",
                    },

                ],
            },
            "creamy-vanilla": {
                name: "Creamy Vanilla",
                products: [
                    {
                        name: "Creamy Vanilla Dream",
                        code: "sweet-140",
                        description: "Madagascar vanilla, cream, caramel",
                        notes: {
                            top: ["Rose", "Jasmine", "Amber"],
                            middle: ["Vanilla", "Tobacco"],
                            base: ["Saffron", "Agarwood"],
                        },
                        occasions: ["Formal"],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/919218a719619f2007696dfd41c6f7cf.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/sweet-140",
                    },
                    {
                        name: "Vanilla Silk",
                        code: "sweet-141",
                        description: "Vanilla, silk, white musk",
                        notes: {
                            top: ["Vanilla", "Sandalwood"],
                            middle: ["Geranium", "Rose"],
                            base: ["Amber", "Cedarwood", "Musk"],
                        },
                        occasions: ["Special Occasion"],
                        longevity: "7-9 hours",
                        sillage: "Moderate to Strong",
                        season: "All Seasons",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/d21f708d91441b0f1b081f457486e55b.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/sweet-141",
                    },
                    {
                        name: "Vanilla Bean Bliss",
                        code: "sweet-151",
                        description: "Vanilla bean, honey, sandalwood",
                        notes: {
                            top: ["Sugar", "Cocoa"],
                            middle: ["Vanilla", "Dark Chocolate"],
                            base: ["Amber", "Sugarcane"],
                        },
                        occasions: ["Special Occasion"],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/5e516d0a47dd0b364871ee58626d91cb.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/sweet-151",
                    },
                ],
            },
            "berries-musk": {
                name: "Berries & Musk",
                products: [
                    {
                        name: "Berry Musk Spark",
                        code: "sweet-143",
                        description: "Sweet berries with musky undertones",
                        notes: {
                            top: ["Lemon", "Blackcurrant", "Violet Leaf"],
                            middle: ["Orange Blossom", "Rose"],
                            base: ["Musk", "Sandalwood", "Civet"],
                        },
                        occasions: ["Sports"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "All",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-143_67a55ecc-7062-4578-9ad9-14141bcaf457.jpg?v=1758281086",
                        link: "https://wanaromah.com/products/sweet-143",
                    },

                    {
                        name: "Berry Musk Delight",
                        code: "sweet-144",
                        description: "Blackberry, raspberry, white musk",
                        notes: {
                            top: ["Floral Notes", "Vanilla", "Orchid"],
                            middle: ["Musk", "Geranium", "Amber"],
                            base: ["Amber", "Cedar", "Musk"],
                        },
                        occasions: ["All"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/27fea49eb423a7745ec1c998e09597d8.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/sweet-144",
                    },
                    {
                        name: "Rose Vanilla Whisper",
                        code: "sweet-149",
                        description: "Gentle rose with sweet vanilla and woods",
                        notes: {
                            top: ["Cassis"],
                            middle: ["Rose", "Freesia"],
                            base: ["Vanilla", "Patchouli", "Woody Notes", "Ambroxan"],
                        },
                        occasions: ["All"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "All",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-149_e868d3a2-de72-46f8-8c7f-836065f9b678.jpg?v=1758281086",
                        link: "https://wanaromah.com/products/sweet-149",
                    },

                    {
                        name: "Mixed Berry Musk",
                        code: "sweet-150",
                        description: "Mixed berries, clean musk",
                        notes: {
                            top: ["Lavender", "Lemon", "Mint", "Basil"],
                            middle: ["Caramel", "Cinnamon", "Strawberry"],
                            base: ["Cedar", "Vetiver", "Amber", "Wood"],
                        },
                        occasions: ["All"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "All Seasons",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/2f7c1bd0949d5c07ef88e64d4e0572f5.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/sweet-150",
                    },
                    {
                        name: "Berry Vanilla Musk",
                        code: "sweet-152",
                        description: "Berries, vanilla, soft musk",
                        notes: {
                            top: ["Big Strawberry"],
                            middle: ["Raspberry", "Apple"],
                            base: ["Sandalwood", "Strawberry"],
                        },
                        occasions: ["Sports"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/50c63c7c48d37404251e3511d71750f1.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/sweet-152",
                    },
                ],
            },
        },
    },
    fresh: {
        name: "✨ Fresh",
        subcategories: {
            "bright-citrus": {
                name: "Bright Citrus",
                products: [
                    {
                        name: "Spiced Bergamot Glow",
                        code: "fresh-117",
                        description: "A warm fusion of bergamot and spice",
                        notes: {
                            top: ["Bergamot", "Lavender"],
                            middle: ["Sichuan Pepper", "Anise", "Nutmeg"],
                            base: ["Amber", "Vanilla"],
                        },
                        occasions: ["Casual"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Autumn/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fresh-117.jpg?v=1758281085",
                        link: "https://wanaromah.com/products/fresh-117",
                    },
                    {
                        name: "Green Tea Harmony",
                        code: "fresh-118",
                        description: "Refreshing green tea blended with citrus and musk",
                        notes: {
                            top: ["Bergamot", "Mandarin Orange"],
                            middle: ["Green Tea", "Black Currant"],
                            base: ["Musk", "Petitgrain", "Sandalwood", "Galbanum"],
                        },
                        occasions: ["Special Occasion"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fresh-118.jpg?v=1758281086",
                        link: "https://wanaromah.com/products/fresh-118",
                    },

                    {
                        name: "Bright Citrus Burst",
                        code: "fresh-124",
                        description: "Lemon, bergamot, grapefruit",
                        notes: {
                            top: ["Bergamot", "Lemon", "Lavender", "Verbena"],
                            middle: [
                                "Red Apple",
                                "Geranium",
                                "Rose",
                                "Coumarin",
                                "Oakmoss",
                            ],
                            base: ["Tonka Beans", "Sandalwood"],
                        },
                        occasions: ["Formal"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/5c222e5464dbf2adf2de2e9b67e79d9a.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/fresh-124",
                    },
                    {
                        name: "Citrus Blossom Veil",
                        code: "fresh-129",
                        description: "Citrusy brightness balanced with soft florals",
                        notes: {
                            top: ["Jasmine", "Bergamot", "Musk"],
                            middle: ["Vanilla", "Orange Blossom"],
                            base: ["Ambergris", "Musk"],
                        },
                        occasions: ["Special Occasion"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fresh-129.jpg?v=1758281085",
                        link: "https://wanaromah.com/products/fresh-129",
                    },

                    {
                        name: "Citrus Sunshine",
                        code: "fresh-130",
                        description: "Orange, lime, citrus zest",
                        notes: {
                            top: ["Saffron", "Jasmine"],
                            middle: ["Amber", "Ambergris"],
                            base: ["Fir Resin", "Cedar"],
                        },
                        occasions: ["Sports"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/7a68d9546066ffb68b3d2665ac381409.jpg?v=1756714910",
                        link: "https://wanaromah.com/products/fresh-130",
                    }, {
                        name: "Citrus Spice Fresh",
                        code: "fresh-133",
                        description: "Zesty citrus blended with aromatic spices",
                        notes: {
                            top: ["Lavender", "Lemon", "Bergamot", "Mandarin Orange"],
                            middle: ["Sage", "Juniper Berries", "Basil", "Coriander"],
                            base: ["Sandalwood", "Vetiver", "Musk", "Amber", "Rosewood"],
                        },
                        occasions: ["All"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fresh-133.jpg?v=1758281085",
                        link: "https://wanaromah.com/products/fresh-133",
                    },

                    {
                        name: "Sparkling Citrus",
                        code: "fresh-134",
                        description: "Sparkling lemon, yuzu, mint",
                        notes: {
                            top: ["Grapefruit", "Tangerine"],
                            middle: ["Pineapple", "Cedar"],
                            base: ["Amber", "Tonka Beans"],
                        },
                        occasions: ["Special Occasion"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/463f4915fc3a7bc410b195b5d425c708.jpg?v=1756714910",
                        link: "https://wanaromah.com/products/fresh-134",
                    },
                ],
            },
            "green-clean": {
                name: "Green & Clean",
                products: [
                    {
                        name: "Citrus Tobacco Twist",
                        code: "fresh-127",
                        description: "A bold play of citrus, florals, and tobacco",
                        notes: {
                            top: ["Neroli", "Apple", "Lemon", "Bergamot"],
                            middle: ["Rose", "Teakwood", "Patchouli"],
                            base: ["Vanilla", "Musk", "Tobacco"],
                        },
                        occasions: ["Sports"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Autumn/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fresh-127.jpg?v=1758281086",
                        link: "https://wanaromah.com/products/fresh-127",
                    },

                    {
                        name: "Green Clean Breeze",
                        code: "fresh-120",
                        description: "Mint, eucalyptus, green tea",
                        notes: {
                            top: ["Bergamot", "Sea Notes", "Coriander"],
                            middle: ["Lavender", "Rosemary", "Geranium", "Neroli"],
                            base: ["Amber", "Musk", "Cedarwood", "Oakmoss"],
                        },
                        occasions: ["All"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/62262d9414fbbf36cbb7bcf039f2f24c.jpg?v=1756807855",
                        link: "https://wanaromah.com/products/fresh-120",
                    },
                    {
                        name: "Fresh Green Leaves",
                        code: "fresh-125",
                        description: "Green leaves, bamboo, dew",
                        notes: {
                            top: ["Sea Water", "Lavender", "Mint", "Coriander"],
                            middle: ["Sandal", "Neroli", "Geranium", "Jasmine"],
                            base: ["Musk", "Tobacco", "Oakmoss", "Cedar", "Amber"],
                        },
                        occasions: ["Sports"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/73d4d85ffc5d24c1d4ad76db69a85241.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/fresh-125",
                    },
                    {
                        name: "Clean Green Air",
                        code: "fresh-128",
                        description: "Clean air, green grass, ozone",
                        notes: {
                            top: ["Musk", "Lime"],
                            middle: ["Herbal Notes"],
                            base: ["Amber", "Sandalwood", "Musk"],
                        },
                        occasions: ["Casual"],
                        longevity: "6-8 hours",
                        sillage: "Light to Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/16a45555b943a3de51991fb3245e42b9.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/fresh-128",
                    },
                ],
            },
            aquatic: {
                name: "Aquatic",
                products: [
                    {
                        name: "Aquatic Ocean Mist",
                        code: "fresh-131",
                        description: "Sea salt, marine accord, driftwood",
                        notes: {
                            top: ["Musk", "Lily", "Galbanum", "Ylang-Ylang"],
                            middle: ["Musk", "Lily", "Rose"],
                            base: [
                                "Musk",
                                "Iris",
                                "Oakmoss",
                                "Peach",
                                "Amber",
                                "Vanilla",
                            ],
                        },
                        occasions: ["All"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/d21f708d91441b0f1b081f457486e55b.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/fresh-131",
                    },
                    {
                        name: "Deep Ocean Breeze",
                        code: "fresh-132",
                        description: "Ocean breeze, seaweed, minerals",
                        notes: {
                            top: ["Lemon", "Mint", "Rosemary", "Bergamot", "Basil"],
                            middle: ["Juniper", "Coriander", "Clove"],
                            base: ["Oakmoss", "Musk", "Patchouli", "Amber", "Resin"],
                        },
                        occasions: ["Formal"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/ea3527c0047505a768231ed301fac3fa.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/fresh-132",
                    },
                ],
            },
        },
    },
    spicy: {
        name: "✨ Spicy",
        subcategories: {
            "clove-peppery": {
                name: "Clove & Peppery",
                products: [
                    {
                        name: "Clove Pepper Heat",
                        code: "spicy-171",
                        description: "Black pepper, clove, cinnamon",
                        notes: {
                            top: ["Bergamot", "Clove", "Lavender", "Lemon", "Basil"],
                            middle: ["Musk", "Juniper", "Coriander", "Cinnamon"],
                            base: [
                                "Cedarwood",
                                "Amber",
                                "Vetiver",
                                "Sandalwood",
                                "Resins",
                                "Oakmoss",
                                "Patchouli",
                            ],
                        },
                        occasions: ["All"],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fb12b60a1bf48adcb7dfd5542c01a45f.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/spicy-171",
                    }, {
                        name: "Fiery Vetiver Spice",
                        code: "spicy-172",
                        description: "Vetiver with chilli heat and warm spices",
                        notes: {
                            top: ["Pepper", "Labdanum"],
                            middle: ["Patchouli", "Rose", "Pepper"],
                            base: ["Benzoin", "Amber", "Vanilla", "Pink Pepper"],
                        },
                        occasions: ["Special Occasion"],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-172_9a25ffa5-fd81-4f35-bdce-672e4289f953.jpg?v=1758281086",
                        link: "https://wanaromah.com/products/spicy-172",
                    },

                    {
                        name: "Peppery Spice Blend",
                        code: "spicy-173",
                        description: "Pink pepper, clove, nutmeg",
                        notes: {
                            top: ["Clove", "Violet Leaf", "Labdanum"],
                            middle: ["Patchouli", "Pink Pepper", "Orange Blossom"],
                            base: ["Benzoin", "Amber", "Vanilla", "Musk"],
                        },
                        occasions: ["Casual"],
                        longevity: "7-9 hours",
                        sillage: "Moderate to Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/9801bd49465d4b4d148ae47cc41e61a6.jpg?v=1756714910",
                        link: "https://wanaromah.com/products/spicy-173",
                    },
                    {
                        name: "Spicy Pepper Fire",
                        code: "spicy-174",
                        description: "Hot pepper, clove, cardamom",
                        notes: {
                            top: ["Nutmeg", "Pepper Berries"],
                            middle: ["Saffron", "Patchouli", "Woody Notes"],
                            base: ["Cumin", "Amber", "Juniper Berries", "Cedar"],
                        },
                        occasions: ["All"],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/912936aee3717776bfaee4fe8e0e7dd2.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/spicy-174",
                    },
                    {
                        name: "Cedar Clove Spice",
                        code: "spicy-177",
                        description: "Spicy clove balanced with woody cedar",
                        notes: {
                            top: ["Bergamot", "Clove", "Lavender", "Lemon", "Basil"],
                            middle: ["Musk", "Juniper", "Coriander", "Cinnamon"],
                            base: ["Cedarwood", "Amber", "Vetiver", "Sandalwood", "Resins", "Oakmoss", "Patchouli"],
                        },
                        occasions: ["Special Occasion"],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-177_c22e889f-5a7a-445d-9131-8e7e6701dcad.jpg?v=1758281085",
                        link: "https://wanaromah.com/products/spicy-177",
                    }

                ],
            },
            "woody-spice": {
                name: "Woody Spice",
                products: [
                    {
                        name: "Woody Cardamom Heat",
                        code: "spicy-175",
                        description: "Warm cardamom and woods with a fruity spark",
                        notes: {
                            top: ["Pear", "Apple", "Grapefruit"],
                            middle: ["Rose", "Pink Pepper", "Cardamom"],
                            base: ["Cinnamon", "Sandalwood", "Musk"],
                        },
                        occasions: ["Casual"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Autumn/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-175_c01ed518-f810-4a78-b624-4bcf26a843f6.jpg?v=1758281085",
                        link: "https://wanaromah.com/products/spicy-175",
                    },
                    {
                        name: "Cedar Spiced Heat",
                        code: "spicy-178",
                        description: "Zesty pepper with warm woody cedar",
                        notes: {
                            top: ["Bergamot", "Pepper"],
                            middle: ["Lavender", "Sichuan Pepper", "Anise", "Nutmeg"],
                            base: ["Amber", "Cedar", "Labdanum"],
                        },
                        occasions: ["Sports"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Autumn/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-178_6f209d9f-36c6-415c-9d0b-30eb4937798d.jpg?v=1758281086",
                        link: "https://wanaromah.com/products/spicy-178",
                    },
                    {
                        name: "Woody Spice Blend",
                        code: "spicy-180",
                        description: "Cardamom, cedar, nutmeg",
                        notes: {
                            top: ["Lavender", "Amalfi Lemon", "Bergamot"],
                            middle: ["Thyme", "Sage", "Pink Pepper", "Cinnamon"],
                            base: ["Tobacco", "Vetiver", "Patchouli"],
                        },
                        occasions: ["Formal"],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/74ddc8f0ded24489aecbe13eb8a19d68.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/spicy-180",
                    },
                    {
                        name: "Spiced Woods",
                        code: "spicy-184",
                        description: "Spiced woods, sandalwood, amber",
                        notes: {
                            top: ["Apple", "Lemon", "Plum", "Cinnamon"],
                            middle: ["Cinnamon", "Mahogany", "Oakmoss"],
                            base: ["Vanilla", "Sandalwood", "Vetiver", "Tobacco"],
                        },
                        occasions: ["Formal"],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/dfc2a5c42262f5428114f8928d36c696.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/spicy-184",
                    },
                ],
            },
            "leather-smoke": {
                name: "Leather & Smoke",
                products: [
                    {
                        name: "Leather Smoke Mystery",
                        code: "spicy-179",
                        description: "Smoky leather, tobacco, spices",
                        notes: {
                            top: ["Nutmeg Flower", "Cedar", "Chamomile", "Hawthorn"],
                            middle: ["Nutmeg", "Sandalwood", "Honeysuckle"],
                            base: ["Leather", "Tonka Beans", "Vetiver", "Patchouli"],
                        },
                        occasions: ["Casual"],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/caf0afb3b00ee373e8ad476204b2b8c3.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/spicy-179",
                    },
                    {
                        name: "Smoky Leather Blend",
                        code: "spicy-181",
                        description: "Leather, smoke, dark spices",
                        notes: {
                            top: ["Basil", "Galbanum", "Nutmeg Flower", "Artemisia"],
                            middle: [
                                "Pine Tree Needles",
                                "Nutmeg",
                                "Patchouli",
                                "Spices",
                                "Vetiver",
                            ],
                            base: [
                                "Leather",
                                "Benzoin",
                                "Coconut",
                                "Tonka Beans",
                                "Amber",
                                "Vanilla",
                                "Sandalwood",
                            ],
                        },
                        occasions: ["Sports"],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/004f82da822a34ce2bc697ba404dab79.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/spicy-181",
                    },
                    {
                        name: "Patchouli Pepper Blend",
                        code: "spicy-183",
                        description: "Patchouli layered with pepper and woody musk",
                        notes: {
                            top: ["Nutmeg", "Pink Pepper", "Bergamot"],
                            middle: ["Patchouli", "Cedar", "Sandalwood"],
                            base: ["Civette", "Amber", "Musk", "Oakmoss"],
                        },
                        occasions: ["All"],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Autumn/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-183_c46e7814-e3c5-45d3-9e5f-7937aafc3a86.jpg?v=1758281086",
                        link: "https://wanaromah.com/products/spicy-183",
                    }

                ],
            },
            "fresh-spice": {
                name: "Fresh Spice (Minty/Basil)",
                products: [
                    {
                        name: "Chilli Citrus Zest",
                        code: "spicy-176",
                        description: "Bright citrus infused with chilli and spice",
                        notes: {
                            top: ["Chilli", "Bergamot"],
                            middle: ["Ginger", "Vetiver"],
                            base: ["Vetiver", "Cypress", "Laurel", "Chilli Berry"],
                        },
                        occasions: ["Sports"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-176_3b249775-6edc-4ec2-9f5e-6d01ede8f5c5.jpg?v=1758281086",
                        link: "https://wanaromah.com/products/spicy-176",
                    },
                    {
                        name: "Basil Musk Fusion",
                        code: "spicy-182",
                        description: "Aromatic basil blended with spiced musk",
                        notes: {
                            top: ["Lavender", "Anise", "Basil", "Lemon"],
                            middle: ["Ylang-Ylang", "Geranium", "Nutmeg"],
                            base: ["Coumarin", "Musk", "Sandalwood", "Tonka Beans", "Vetiver", "Patchouli", "Vanilla"],
                        },
                        occasions: ["Formal"],
                        longevity: "8-10 hours",
                        sillage: "Strong",
                        season: "Autumn/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-182_7dab2d10-d734-4908-bc94-1cb8a8e209d3.jpg?v=1758281085",
                        link: "https://wanaromah.com/products/spicy-182",
                    },
                    {
                        name: "Ginger Smoke Incense",
                        code: "spicy-185",
                        description: "Zesty ginger with smoky incense and spice",
                        notes: {
                            top: ["Ginger", "Lemon", "Mint"],
                            middle: ["Nutmeg", "Pink Pepper", "Ginger"],
                            base: ["Patchouli", "Incense", "Cedar"],
                        },
                        occasions: ["Casual"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Fall/Winter",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-185_3ad4eff9-e7b0-44ac-9584-619ac856f556.jpg?v=1758281086",
                        link: "https://wanaromah.com/products/spicy-185",
                    },


                    {
                        name: "Fresh Spice Garden",
                        code: "spicy-186",
                        description: "Basil, mint, pink pepper",
                        notes: {
                            top: ["Peppermint", "Bergamot"],
                            middle: ["Mint", "Vetiver", "Lemon"],
                            base: ["Cinnamon", "Musk", "Sandalwood"],
                        },
                        occasions: ["Sports"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/4022d4c054286d625305440962a03dec.jpg?v=1756714911",
                        link: "https://wanaromah.com/products/spicy-186",
                    },
                    {
                        name: "Minty Spice Blend",
                        code: "spicy-187",
                        description: "Mint, basil, green cardamom",
                        notes: {
                            top: ["Peppermint", "Anise", "Basil"],
                            middle: ["Lavender", "Bergamot"],
                            base: ["Sandalwood", "Vanilla", "Musk"],
                        },
                        occasions: ["Special Occasion"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "Spring/Summer",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/bfbe3520e7b297edc8069765d3a4ef43.jpg?v=1756807854",
                        link: "https://wanaromah.com/products/spicy-187",
                    },
                    {
                        name: "Herbal Spice Fresh",
                        code: "spicy-188",
                        description: "Fresh herbs, spices, mint",
                        notes: {
                            top: ["Mint", "Lemon", "Rosemary"],
                            middle: ["Musk", "Cinnamon", "Juniper"],
                            base: ["Musk"],
                        },
                        occasions: ["All"],
                        longevity: "6-8 hours",
                        sillage: "Moderate",
                        season: "All Seasons",
                        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/8802a457a91d87141e17cb3f6016eaea.jpg?v=1756810438",
                        link: "https://wanaromah.com/products/spicy-188",
                    },
                ],
            },
        },
    },
};

var booster = {
    lxe: {
        name: "LXE",
        products: [
            {
                name: "Oud Amber Glow",
                code: "lxe-1008",
                description: "Bulgarian rose, oud, amber",
                notes: {
                    top: ["Bulgarian Rose", "Bergamot"],
                    middle: ["Oud Wood", "Rose Petals"],
                    base: ["Amber", "Sandalwood", "Musk"],
                },
                occasions: [
                    "Evening wear",
                    "Special occasions",
                    "Date nights",
                    "Formal events",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                vid: "https://www.youtube.com/watch?v=example1",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/067b0e2fdb238975d6567015ae713ec0.jpg?v=1756711135"
            },
            {
                name: "Petrichor Vetiver",
                code: "lxe-1011",
                description: "Rain-kissed vetiver & woods",
                notes: {
                    top: ["Wet Earth", "Green Leaves"],
                    middle: ["Vetiver", "Cedarwood"],
                    base: ["Sandalwood", "Moss", "Amber"],
                },
                occasions: [
                    "Casual wear",
                    "Office",
                    "Outdoor activities",
                    "Meditation",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Fall",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/84a7160bb120b094d64514271e5a6c54.jpg?v=1756711135"
            },
            {
                name: "Burnt Rose & Agarwood",
                code: "lxe-1016",
                description: "Saffron incense & oud",
                notes: {
                    top: ["Saffron", "Rose Petals"],
                    middle: ["Agarwood", "Incense"],
                    base: ["Amber", "Sandalwood", "Musk"],
                },
                occasions: [
                    "Evening wear",
                    "Cultural events",
                    "Meditation",
                    "Special ceremonies",
                ],
                longevity: "10-12 hours",
                sillage: "Very Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/9b184766ecb17ab23661259786411b12.jpg?v=1756711135"
            },
            {
                name: "Animalic Agarwood",
                code: "lxe-1031",
                description: "Wild oud & civet amber",
                notes: {
                    top: ["Wild Herbs", "Spices"],
                    middle: ["Agarwood", "Civet"],
                    base: ["Amber", "Animalic Musk", "Leather"],
                },
                occasions: [
                    "Evening wear",
                    "Confidence boost",
                    "Special occasions",
                    "Cold weather",
                ],
                longevity: "12+ hours",
                sillage: "Very Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/815fcdb2b4d4b4128ab517b630940989.jpg?v=1756807854"
            },
            {
                name: "Warm Spicy Aura",
                code: "lxe-1038",
                description: "Cardamom, violet, patchouli",
                notes: {
                    top: ["Cardamom", "Pink Pepper"],
                    middle: ["Violet", "Rose"],
                    base: ["Patchouli", "Sandalwood", "Amber"],
                },
                occasions: [
                    "Evening wear",
                    "Date nights",
                    "Cooler weather",
                    "Artistic events",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/111b6360357314803b93a8b43accafe5.jpg?v=1756711135"
            },
            {
                name: "Burnt Sugar & Amber",
                code: "lxe-1022",
                description: "Saffron sugar, sandal, ambergris",
                notes: {
                    top: ["Saffron", "Caramelized Sugar"],
                    middle: ["Sandalwood", "Rose"],
                    base: ["Ambergris", "Vanilla", "Musk"],
                },
                occasions: [
                    "Evening wear",
                    "Romantic dinners",
                    "Special occasions",
                    "Cold weather",
                ],
                longevity: "10-12 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/8655d3e919a25137ce161e327046646d.jpg?v=1756711135"
            },

            {
                name: "Burnt Vanilla Sugarcane",
                code: "lxe-1009",
                description: "Burnt sugar, vanilla, tobacco",
                notes: {
                    top: ["Burnt Sugar", "Caramel"],
                    middle: ["Madagascar Vanilla", "Tobacco Leaf"],
                    base: ["Amber", "Sandalwood", "Musk"],
                },
                occasions: [
                    "Evening wear",
                    "Date nights",
                    "Cozy gatherings",
                    "Cold weather",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/bedf0b3ba60a595a4f084fd5c94a5442.jpg?v=1756711136"
            },
            {
                name: "Burnt Vanilla & Coffee",
                code: "lxe-1030",
                description: "Warm vanilla, deep musk, coffee",
                notes: {
                    top: ["Coffee Bean", "Cardamom"],
                    middle: ["Vanilla", "Caramel"],
                    base: ["Deep Musk", "Sandalwood", "Amber"],
                },
                occasions: [
                    "Morning wear",
                    "Office",
                    "Casual outings",
                    "Coffee dates",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/b860f8da5c8c8a92a0180cc07c2f24c8.jpg?v=1756711135"
            },
            {
                name: "Mango Almond Silk",
                code: "lxe-1018",
                description: "Almond cream, mango, sandalwood",
                notes: {
                    top: ["Mango", "Bergamot"],
                    middle: ["Almond Cream", "Coconut"],
                    base: ["Sandalwood", "Vanilla", "White Musk"],
                },
                occasions: [
                    "Summer evenings",
                    "Tropical vacations",
                    "Romantic dinners",
                    "Special occasions",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/6f558209bca8c009629e9ebb40fa8633.jpg?v=1756711135"
            },
            {
                name: "Sweet Fresh Champagne",
                code: "lxe-1035",
                description: "Quince, freesia, almond musk",
                notes: {
                    top: ["Quince", "Pear", "Sparkling Notes"],
                    middle: ["Freesia", "Lily of the Valley"],
                    base: ["Almond Musk", "Vanilla", "Sandalwood"],
                },
                occasions: [
                    "Celebrations",
                    "Daytime events",
                    "Spring outings",
                    "Brunch dates",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/48200636f966493b835b3e3f3bf7bd64.jpg?v=1756711136"
            },
            {
                name: "Sweet Citrus Glow",
                code: "lxe-1037",
                description: "Tangerine, green apple, vanilla",
                notes: {
                    top: ["Tangerine", "Green Apple", "Lemon"],
                    middle: ["Orange Blossom", "Peach"],
                    base: ["Vanilla", "White Musk", "Cedarwood"],
                },
                occasions: [
                    "Daytime wear",
                    "Casual outings",
                    "Work",
                    "Spring activities",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/584f9d1204cbb93779eeadcc1f51c84f.jpg?v=1756711136"
            },
            {
                name: "Green Vanilla Veil",
                code: "lxe-1036",
                description: "Lemon, mint, tonka, Madagascar vanilla",
                notes: {
                    top: ["Lemon", "Mint", "Green Leaves"],
                    middle: ["Tonka Bean", "Coconut"],
                    base: ["Madagascar Vanilla", "Sandalwood", "Musk"],
                },
                occasions: [
                    "Daytime wear",
                    "Spring outings",
                    "Casual events",
                    "Fresh starts",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/0036e24b3412ba80e3e24cc3020a1bab.jpg?v=1756711135"
            },

            {
                name: "Sandal Green Amber",
                code: "lxe-1012",
                description: "Green citrus, sandal, cedar",
                notes: {
                    top: ["Green Citrus", "Bergamot", "Lime"],
                    middle: ["Sandalwood", "Geranium"],
                    base: ["Cedar", "Amber", "White Musk"],
                },
                occasions: [
                    "Daytime wear",
                    "Office",
                    "Casual outings",
                    "Spring activities",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fa8115a116bd1d72193cb6d7d0de9404.jpg?v=1756711136"
            },
            {
                name: "Citrus & Warm Spice",
                code: "lxe-1014",
                description: "Cinnamon, nutmeg, lavender woods",
                notes: {
                    top: ["Cinnamon", "Nutmeg", "Orange"],
                    middle: ["Lavender", "Geranium"],
                    base: ["Sandalwood", "Cedar", "Amber"],
                },
                occasions: [
                    "Daytime wear",
                    "Autumn walks",
                    "Cozy gatherings",
                    "Weekend activities",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Fall/Spring",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/2120186066c813757ae4661e6a763e48.jpg?v=1756807853"
            },
            {
                name: "Sea Salt & Tobacco",
                code: "lxe-1032",
                description: "Marine air, orchid, incense",
                notes: {
                    top: ["Sea Salt", "Marine Air", "Ozone"],
                    middle: ["Orchid", "Tobacco Leaf"],
                    base: ["Incense", "Driftwood", "Amber"],
                },
                occasions: [
                    "Evening wear",
                    "Meditation",
                    "Coastal walks",
                    "Artistic events",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/dfcf26d5444e1900486f42e7a948b537.jpg?v=1756711136"
            },
        ],
    },
    oriental: {
        name: "Oriental",

        products: [
            {
                name: "Dark Tobacco Essence",
                code: "oriental-107",
                description: "Dark tobacco, leather, amber",
                notes: {
                    top: ["Black Pepper", "Bergamot"],
                    middle: ["Dark Tobacco", "Leather"],
                    base: ["Amber", "Sandalwood", "Musk"],
                },
                occasions: [
                    "Evening wear",
                    "Business meetings",
                    "Cold weather",
                    "Formal events",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                price: {
                    "130ml": 2950,
                    "55ml": 2000,
                    "30ml": 1770,
                },
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/16c856b316b44f7c630e0879f7f5f220.jpg?v=1756711777",
                link: "https://wanaromah.com/products/oriental-107",
            },
            {
                name: "Smoky Oud Mystery",
                code: "oriental-110",
                description: "Smoky oud, incense, vanilla",
                notes: {
                    top: ["Incense", "Saffron"],
                    middle: ["Smoky Oud", "Rose"],
                    base: ["Vanilla", "Amber", "Sandalwood"],
                },
                occasions: [
                    "Evening wear",
                    "Meditation",
                    "Special occasions",
                    "Cultural events",
                ],
                longevity: "10-12 hours",
                sillage: "Very Strong",
                season: "Fall/Winter",
                price: {
                    "130ml": 2950,
                    "55ml": 2000,
                    "30ml": 1770,
                },
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/05d0d1ba3e1df524644df3c06a249d84.jpg?v=1756711777",
                link: "https://wanaromah.com/products/oriental-110",
            },
            {
                name: "Leather & Smoke",
                code: "oriental-116",
                description: "Leather, smoke, dark woods",
                notes: {
                    top: ["Smoke", "Black Pepper"],
                    middle: ["Leather", "Dark Woods"],
                    base: ["Sandalwood", "Amber", "Musk"],
                },
                occasions: [
                    "Evening wear",
                    "Business meetings",
                    "Formal events",
                    "Winter wear",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                price: {
                    "130ml": 2950,
                    "55ml": 2000,
                    "30ml": 1770,
                },
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/af2ba6e737f5a50b50bd8f5ad485ed0c.jpg?v=1756711777",
                link: "https://wanaromah.com/products/oriental-116",
            },
            {
                name: "Frankincense Dreams",
                code: "oriental-099",
                description: "Frankincense, myrrh, sandalwood",
                notes: {
                    top: ["Frankincense", "Bergamot"],
                    middle: ["Myrrh", "Rose"],
                    base: ["Sandalwood", "Amber", "Musk"],
                },
                occasions: [
                    "Meditation",
                    "Evening wear",
                    "Spiritual events",
                    "Cold weather",
                ],
                longevity: "10-12 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                price: {
                    "130ml": 2950,
                    "55ml": 2000,
                    "30ml": 1770,
                },
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/a076331b4f164006901184c6ed2c1912.jpg?v=1756711778",
                link: "https://wanaromah.com/products/oriental-099",
            },
            {
                name: "Amber Resin Glow",
                code: "oriental-101",
                description: "Amber resin, benzoin, vanilla",
                notes: {
                    top: ["Bergamot", "Orange"],
                    middle: ["Amber Resin", "Benzoin"],
                    base: ["Vanilla", "Sandalwood", "Musk"],
                },
                occasions: [
                    "Evening wear",
                    "Date nights",
                    "Cozy gatherings",
                    "Cold weather",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                price: {
                    "130ml": 2950,
                    "55ml": 2000,
                    "30ml": 1770,
                },
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/7d06fae0a44c69522d28f8864f5edbbc.jpg?v=1756711778",
                link: "https://wanaromah.com/products/oriental-101",
            },
            {
                name: "Rich Oud Blend",
                code: "oriental-111",
                description: "Rich oud, amber, spices",
                notes: {
                    top: ["Saffron", "Cardamom"],
                    middle: ["Rich Oud", "Rose"],
                    base: ["Amber", "Sandalwood", "Musk"],
                },
                occasions: [
                    "Special occasions",
                    "Evening wear",
                    "Celebrations",
                    "Formal events",
                ],
                longevity: "12+ hours",
                sillage: "Very Strong",
                season: "Fall/Winter",
                price: {
                    "130ml": 2950,
                    "55ml": 2000,
                    "30ml": 1770,
                },
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/95af9f0fc9dde2ec00c662b37ba4bef4.jpg?v=1756711778",
                link: "https://wanaromah.com/products/oriental-111",
            },
            {
                name: "Oriental Mystique",
                code: "oriental-105",
                description: "Oriental spices, amber, sandalwood",
                notes: {
                    top: ["Cardamom", "Cinnamon"],
                    middle: ["Oriental Spices", "Amber"],
                    base: ["Sandalwood", "Musk", "Vanilla"],
                },
                occasions: [
                    "Evening wear",
                    "Cultural events",
                    "Special occasions",
                    "Cold weather",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                price: {
                    "130ml": 2950,
                    "55ml": 2000,
                    "30ml": 1770,
                },
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/2c7685114d4a7770e9a2b2545526703a.jpg?v=1756711778",
                link: "https://wanaromah.com/products/oriental-105",
            },
            {
                name: "Oriental Harmony",
                code: "oriental-112",
                description: "Balanced oriental blend, amber, woods",
                notes: {
                    top: ["Bergamot", "Spices"],
                    middle: ["Oriental Blend", "Amber"],
                    base: ["Woods", "Sandalwood", "Musk"],
                },
                occasions: [
                    "All occasions",
                    "Business",
                    "Evening wear",
                    "Formal events",
                ],
                longevity: "8-10 hours",
                sillage: "Moderate to Strong",
                season: "All seasons",
                price: {
                    "130ml": 2950,
                    "55ml": 2000,
                    "30ml": 1770,
                },
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/d017d548dbec0adfaa05e8d164ca1c65.jpg?v=1756711777",
                link: "https://wanaromah.com/products/oriental-112",
            },
            {
                name: "Oriental Luxury",
                code: "oriental-115",
                description:
                    "Luxury oriental spices, gold amber, precious woods",
                notes: {
                    top: ["Saffron", "Cardamom"],
                    middle: ["Luxury Spices", "Gold Amber"],
                    base: ["Precious Woods", "Oud", "Musk"],
                },
                occasions: [
                    "Luxury events",
                    "Special occasions",
                    "VIP gatherings",
                    "Formal ceremonies",
                ],
                longevity: "10-12 hours",
                sillage: "Very Strong",
                season: "Fall/Winter",
                price: {
                    "130ml": 2950,
                    "55ml": 2000,
                    "30ml": 1770,
                },
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/303e3cf402f15fdbea3aa23724dbc1a7.jpg?v=1756711777",
                link: "https://wanaromah.com/products/oriental-115",
            },
            {
                name: "Rose Oud Harmony",
                code: "oriental-108",
                description: "Rose, oud, jasmine",
                notes: {
                    top: ["Rose", "Bergamot"],
                    middle: ["Oud", "Jasmine"],
                    base: ["Sandalwood", "Amber", "Musk"],
                },
                occasions: [
                    "Evening wear",
                    "Date nights",
                    "Romantic dinners",
                    "Special occasions",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "All seasons",
                price: {
                    "130ml": 2950,
                    "55ml": 2000,
                    "30ml": 1770,
                },
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/888b25797840e649143cfa8969359e0e.jpg?v=1756711778",
                link: "https://wanaromah.com/products/oriental-108",
            },
            {
                name: "Jasmine Oud Dream",
                code: "oriental-113",
                description: "Jasmine, oud, sandalwood",
                notes: {
                    top: ["Jasmine", "Bergamot"],
                    middle: ["Oud", "Rose"],
                    base: ["Sandalwood", "Amber", "Musk"],
                },
                occasions: [
                    "Evening wear",
                    "Romantic occasions",
                    "Cultural events",
                    "Special dinners",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Spring/Fall",
                price: {
                    "130ml": 2950,
                    "55ml": 2000,
                    "30ml": 1770,
                },
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/4ff1da6570a15c78a554d2462b676f85.jpg?v=1756711778",
                link: "https://wanaromah.com/products/oriental-113",
            },
            {
                name: "Vanilla Tobacco Dream",
                code: "oriental-109",
                description: "Vanilla tobacco, warm amber",
                notes: {
                    top: ["Bergamot", "Spices"],
                    middle: ["Vanilla Tobacco", "Honey"],
                    base: ["Warm Amber", "Sandalwood", "Musk"],
                },
                occasions: [
                    "Evening wear",
                    "Cozy gatherings",
                    "Date nights",
                    "Cold weather",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                price: {
                    "130ml": 2950,
                    "55ml": 2000,
                    "30ml": 1770,
                },
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/03eea0ea321794d3011881bff3d94d1b.jpg?v=1756711778",
                link: "https://wanaromah.com/products/oriental-109",
            },
            {
                name: "Amber Tobacco Blend",
                code: "oriental-114",
                description: "Amber, tobacco leaf, honey",
                notes: {
                    top: ["Honey", "Bergamot"],
                    middle: ["Tobacco Leaf", "Spices"],
                    base: ["Amber", "Sandalwood", "Vanilla"],
                },
                occasions: [
                    "Evening wear",
                    "Autumn activities",
                    "Cozy settings",
                    "Special occasions",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                price: {
                    "130ml": 2950,
                    "55ml": 2000,
                    "30ml": 1770,
                },
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/1f3b3a5a5ebfd7bfb5297102a9a47b6f.jpg?v=1756711777",
                link: "https://wanaromah.com/products/oriental-114",
            },
        ],
    }, floral: {
        name: "Floral",
        products: [
            {
                name: "Rose Garden Romance",
                code: "floral-159",
                description: "Red rose, peony, rose water",
                notes: {
                    top: ["Rose Water", "Bergamot"],
                    middle: ["Red Rose", "Peony"],
                    base: ["Sandalwood", "Musk", "Amber"],
                },
                occasions: [
                    "Date nights",
                    "Romantic dinners",
                    "Spring events",
                    "Wedding occasions",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/8cf0f2b7a46ea55ec76f15ec443666e2.jpg?v=1756714910",
                link: "https://wanaromah.com/products/floral-159",
            },
            {
                name: "Bulgarian Rose Essence",
                code: "floral-170",
                description: "Bulgarian rose, damask rose, musk",
                notes: {
                    top: ["Bulgarian Rose", "Lemon"],
                    middle: ["Damask Rose", "Geranium"],
                    base: ["White Musk", "Sandalwood", "Amber"],
                },
                occasions: [
                    "Special occasions",
                    "Evening wear",
                    "Formal events",
                    "Romantic settings",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/8e47d0bd73dafa1d339cb2b2b13c2b7e.jpg?v=1756714911",
                link: "https://wanaromah.com/products/floral-188",
            },
            {
                name: "Rose Petals Dream",
                code: "floral-166",
                description: "Rose petals, vanilla, sandalwood",
                notes: {
                    top: ["Rose Petals", "Bergamot"],
                    middle: ["Rose", "Jasmine"],
                    base: ["Vanilla", "Sandalwood", "Musk"],
                },
                occasions: [
                    "Evening wear",
                    "Cozy gatherings",
                    "Date nights",
                    "Self-care moments",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fdb4a770776a2cdbd74847f412764ae7.jpg?v=1756714910",
                link: "https://wanaromah.com/products/floral-191",
            },
            {
                name: "White Floral Bouquet",
                code: "floral-154",
                description: "Tuberose, gardenia, lily",
                notes: {
                    top: ["Lily", "Bergamot"],
                    middle: ["Tuberose", "Gardenia"],
                    base: ["Sandalwood", "Musk", "Amber"],
                },
                occasions: [
                    "Evening wear",
                    "Special occasions",
                    "Formal events",
                    "Wedding celebrations",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/80f4728c79eb197fb265d1ad810bf8f7.jpg?v=1756714910",
                link: "https://wanaromah.com/products/floral-154",
            },
            {
                name: "Tuberose Night",
                code: "floral-163",
                description: "Tuberose, jasmine, white musk",
                notes: {
                    top: ["Tuberose", "Bergamot"],
                    middle: ["Jasmine", "White Florals"],
                    base: ["White Musk", "Sandalwood", "Amber"],
                },
                occasions: [
                    "Evening wear",
                    "Date nights",
                    "Romantic occasions",
                    "Night events",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/4125fbadf2a65c4158c460d8bc567646.jpg?v=1756807854",
                link: "https://wanaromah.com/products/floral-194",
            },
            {
                name: "Gardenia Dreams",
                code: "floral-165",
                description: "Gardenia, magnolia, cream",
                notes: {
                    top: ["Gardenia", "Bergamot"],
                    middle: ["Magnolia", "White Florals"],
                    base: ["Cream", "Sandalwood", "Musk"],
                },
                occasions: [
                    "Daytime wear",
                    "Spring events",
                    "Romantic settings",
                    "Garden parties",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/6b37a6814550576bdf4eac3d7e64cb85.jpg?v=1756714911",
                link: "https://wanaromah.com/products/floral-165",
            },
            {
                name: "Peach Blossom Joy",
                code: "floral-161",
                description: "Peach blossom, cherry, magnolia",
                notes: {
                    top: ["Peach Blossom", "Bergamot"],
                    middle: ["Cherry", "Magnolia"],
                    base: ["Sandalwood", "Musk", "Vanilla"],
                },
                occasions: [
                    "Daytime wear",
                    "Spring events",
                    "Casual outings",
                    "Cheerful moments",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/e50f16274de41d49a5ecf9659a57eb57.jpg?v=1756714911",
                link: "https://wanaromah.com/products/floral-161",
            },
            {
                name: "Fruity Floral Fusion",
                code: "floral-164",
                description: "Pear, freesia, white florals",
                notes: {
                    top: ["Pear", "Bergamot"],
                    middle: ["Freesia", "White Florals"],
                    base: ["White Musk", "Sandalwood", "Amber"],
                },
                occasions: [
                    "Daytime wear",
                    "Office",
                    "Casual elegance",
                    "Spring activities",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/891bf04e632aea9a9c356ed640dee81c.jpg?v=1756807855",
                link: "https://wanaromah.com/products/floral-193",
            },
            {
                name: "Berry Blossom",
                code: "floral-168",
                description: "Berry, cherry blossom, musk",
                notes: {
                    top: ["Berry", "Bergamot"],
                    middle: ["Cherry Blossom", "Florals"],
                    base: ["Clean Musk", "Sandalwood", "Vanilla"],
                },
                occasions: [
                    "Daytime wear",
                    "Casual outings",
                    "Spring events",
                    "Youthful moments",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/f34ce2ecfd6605a86cafce001d8ed2f2.jpg?v=1756714911",
                link: "https://wanaromah.com/products/floral-189",
            },
            {
                name: "Oceanic Floral Breeze",
                code: "floral-158",
                description: "Sea lily, salt air, driftwood",
                notes: {
                    top: ["Sea Lily", "Salt Air"],
                    middle: ["Marine Florals", "Seaweed"],
                    base: ["Driftwood", "Musk", "Amber"],
                },
                occasions: [
                    "Daytime wear",
                    "Beach activities",
                    "Summer events",
                    "Fresh moments",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/3ed3ef537a35c52e5c6ac8208822783b.jpg?v=1756714911",
                link: "https://wanaromah.com/products/floral-158",
            },
            {
                name: "Green Floral Garden",
                code: "floral-160",
                description: "Green florals, ivy, sea breeze",
                notes: {
                    top: ["Green Florals", "Sea Breeze"],
                    middle: ["Ivy", "Garden Flowers"],
                    base: ["Green Musk", "Sandalwood", "Amber"],
                },
                occasions: [
                    "Daytime wear",
                    "Garden parties",
                    "Fresh moments",
                    "Nature walks",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/5f8780c20eff5ac8a3c5d4e769ca9bbe.jpg?v=1756714911",
                link: "https://wanaromah.com/products/floral-160",
            },
            {
                name: "Floral Elegance",
                code: "floral-157",
                description: "Mixed florals, elegance, sophistication",
                notes: {
                    top: ["Mixed Florals", "Bergamot"],
                    middle: ["Rose", "Jasmine"],
                    base: ["Sandalwood", "Musk", "Amber"],
                },
                occasions: [
                    "All occasions",
                    "Office",
                    "Evening wear",
                    "Formal events",
                ],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/c78ef2a9cc8afdd559c8e15aa43c3943.jpg?v=1756714911",
                link: "https://wanaromah.com/products/floral-157",
            },
            {
                name: "Floral Symphony",
                code: "floral-162",
                description: "Harmonious floral blend, symphony of flowers",
                notes: {
                    top: ["Floral Blend", "Bergamot"],
                    middle: ["Rose", "Jasmine", "Lily"],
                    base: ["Sandalwood", "Musk", "Amber"],
                },
                occasions: [
                    "Special occasions",
                    "Evening wear",
                    "Formal events",
                    "Celebrations",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/6da38171e3a6e6419c46400484f68c78.jpg?v=1756714910",
                link: "https://wanaromah.com/products/floral-195",
            },
            {
                name: "Floral Whisper",
                code: "floral-167",
                description: "Soft florals, whisper, delicate",
                notes: {
                    top: ["Soft Florals", "Bergamot"],
                    middle: ["Delicate Rose", "Jasmine"],
                    base: ["White Musk", "Sandalwood", "Amber"],
                },
                occasions: [
                    "Daytime wear",
                    "Office",
                    "Intimate moments",
                    "Subtle elegance",
                ],
                longevity: "6-8 hours",
                sillage: "Light to Moderate",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/3581fb84acec0a0451cc66b1defe9acf.jpg?v=1756714911",
                link: "https://wanaromah.com/products/floral-190",
            },
            {
                name: "Floral Mystique",
                code: "floral-169",
                description: "Mysterious florals, mystique, enchanting",
                notes: {
                    top: ["Mysterious Florals", "Bergamot"],
                    middle: ["Enchanting Flowers", "Spices"],
                    base: ["Sandalwood", "Musk", "Amber"],
                },
                occasions: [
                    "Evening wear",
                    "Special occasions",
                    "Mysterious moments",
                    "Enchanting events",
                ],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/42f77282d2a94484c8a6272075ccbfc8.jpg?v=1756714910",
                link: "https://wanaromah.com/products/floral-171",
            },
        ],


    },
    sweet: {
        name: "Sweet",
        products: [
            {
                name: "Raspberry Floral Charm",
                code: "sweet-136",
                description: "Juicy raspberry and floral tones with honey",
                notes: {
                    top: ["Raspberry", "Neroli", "Amalfi Lemon"],
                    middle: ["Jasmine", "Gardenia"],
                    base: ["White Honey", "Patchouli", "Amber"],
                },
                occasions: ["Special Occasion"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-136_fbb17a80-fda1-490b-8be5-a663b28af887.jpg?v=1758281195",
                link: "https://wanaromah.com/products/sweet-136",
            },

            {
                name: "Fruity Playful Mix",
                code: "sweet-137",
                description: "Strawberry, peach, vanilla",
                notes: {
                    top: ["Pear", "Red Berries"],
                    middle: ["Gardenia", "Frangipani"],
                    base: ["Patchouli", "Musk"],
                },
                occasions: ["Casual"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/e4896babf6d661083d25dc7ac1a8b13d.jpg?v=1756714911",
                link: "https://wanaromah.com/products/sweet-137",
            },
            {
                name: "Tropical Berry Coconut",
                code: "sweet-138",
                description: "Exotic blend of berries, coconut, and florals",
                notes: {
                    top: ["Mango", "Blood Orange"],
                    middle: ["Raspberry", "Star Apple", "Water Lily"],
                    base: ["Musk", "Coconut", "Sandalwood"],
                },
                occasions: ["All"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-138_649eaba9-46c5-498b-8cce-19a7d08d3b16.jpg?v=1758281085",
                link: "https://wanaromah.com/products/sweet-138",
            },

            {
                name: "Berry Burst Joy",
                code: "sweet-139",
                description: "Mixed berries, sugar, musk",
                notes: {
                    top: ["Amalfi Lemon", "Mandarin Orange"],
                    middle: ["Nagarmotha", "Sea Notes"],
                    base: ["Amber", "Patchouli"],
                },
                occasions: ["Formal"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/51c814671a6fad5176cc222906dbde71.jpg?v=1756714910",
                link: "https://wanaromah.com/products/sweet-139",
            }, {
                name: "Citrus Floral Essence",
                code: "sweet-142",
                description: "Zesty citrus blended with elegant florals",
                notes: {
                    top: ["Lime", "Bergamot", "Blackcurrant", "Plum"],
                    middle: ["Iris", "Rose", "Jasmine"],
                    base: ["Musk", "Ambergris", "Cedar", "Sandalwood"],
                },
                occasions: ["Formal"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-142_f8409df6-0c0e-4e31-abc2-dec636a4b765.jpg?v=1758281085",
                link: "https://wanaromah.com/products/sweet-142",
            }
            , {
                name: "Citrus Blossom Joy",
                code: "sweet-145",
                description: "Bright mandarin and florals with a woody base",
                notes: {
                    top: ["Mandarin Orange", "Bergamot"],
                    middle: ["Jasmine"],
                    base: ["Cypress", "Pine", "Laurels"],
                },
                occasions: ["Sports"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-145_9081dfa0-0eaa-48a2-8e26-cda1fc18cd4a.jpg?v=1758281085",
                link: "https://wanaromah.com/products/sweet-145",
            },

            {
                name: "Tropical Fruit Dream",
                code: "sweet-146",
                description: "Mango, pineapple, coconut",
                notes: {
                    top: ["Saffron", "Raspberry", "Pineapple"],
                    middle: ["Rose", "Davana"],
                    base: ["Agarwood", "Nagarmotha", "Amber"],
                },
                occasions: ["Special Occasion"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fd887a934c35fe6efcb899a23823c08b.jpg?v=1756714911",
                link: "https://wanaromah.com/products/sweet-146",
            },
            {
                name: "Berry Peony Glow",
                code: "sweet-148",
                description: "Vibrant berries blended with peony and florals",
                notes: {
                    top: ["Passion Fruit", "Grapefruit", "Pineapple", "Strawberry"],
                    middle: ["Peony", "Vanilla Orchid", "Red Berries", "Lily of the Valley"],
                    base: ["Musk", "Cedarwood", "Oakmoss"],
                },
                occasions: ["Casual"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-148_a9481709-2ce1-4c30-adb3-73a11293348a.jpg?v=1758281086",
                link: "https://wanaromah.com/products/sweet-148",
            },


            {
                name: "Creamy Vanilla Dream",
                code: "sweet-140",
                description: "Madagascar vanilla, cream, caramel",
                notes: {
                    top: ["Rose", "Jasmine", "Amber"],
                    middle: ["Vanilla", "Tobacco"],
                    base: ["Saffron", "Agarwood"],
                },
                occasions: ["Formal"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/919218a719619f2007696dfd41c6f7cf.jpg?v=1756714911",
                link: "https://wanaromah.com/products/sweet-140",
            },
            {
                name: "Vanilla Silk",
                code: "sweet-141",
                description: "Vanilla, silk, white musk",
                notes: {
                    top: ["Vanilla", "Sandalwood"],
                    middle: ["Geranium", "Rose"],
                    base: ["Amber", "Cedarwood", "Musk"],
                },
                occasions: ["Special Occasion"],
                longevity: "7-9 hours",
                sillage: "Moderate to Strong",
                season: "All Seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/d21f708d91441b0f1b081f457486e55b.jpg?v=1756714911",
                link: "https://wanaromah.com/products/sweet-141",
            },
            {
                name: "Vanilla Bean Bliss",
                code: "sweet-151",
                description: "Vanilla bean, honey, sandalwood",
                notes: {
                    top: ["Sugar", "Cocoa"],
                    middle: ["Vanilla", "Dark Chocolate"],
                    base: ["Amber", "Sugarcane"],
                },
                occasions: ["Special Occasion"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/5e516d0a47dd0b364871ee58626d91cb.jpg?v=1756714911",
                link: "https://wanaromah.com/products/sweet-151",
            },
            {
                name: "Berry Musk Spark",
                code: "sweet-143",
                description: "Sweet berries with musky undertones",
                notes: {
                    top: ["Lemon", "Blackcurrant", "Violet Leaf"],
                    middle: ["Orange Blossom", "Rose"],
                    base: ["Musk", "Sandalwood", "Civet"],
                },
                occasions: ["Sports"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "All",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-143_67a55ecc-7062-4578-9ad9-14141bcaf457.jpg?v=1758281086",
                link: "https://wanaromah.com/products/sweet-143",
            },

            {
                name: "Berry Musk Delight",
                code: "sweet-144",
                description: "Blackberry, raspberry, white musk",
                notes: {
                    top: ["Floral Notes", "Vanilla", "Orchid"],
                    middle: ["Musk", "Geranium", "Amber"],
                    base: ["Amber", "Cedar", "Musk"],
                },
                occasions: ["All"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/27fea49eb423a7745ec1c998e09597d8.jpg?v=1756714911",
                link: "https://wanaromah.com/products/sweet-144",
            },
            {
                name: "Rose Vanilla Whisper",
                code: "sweet-149",
                description: "Gentle rose with sweet vanilla and woods",
                notes: {
                    top: ["Cassis"],
                    middle: ["Rose", "Freesia"],
                    base: ["Vanilla", "Patchouli", "Woody Notes", "Ambroxan"],
                },
                occasions: ["All"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "All",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-149_e868d3a2-de72-46f8-8c7f-836065f9b678.jpg?v=1758281086",
                link: "https://wanaromah.com/products/sweet-149",
            },

            {
                name: "Mixed Berry Musk",
                code: "sweet-150",
                description: "Mixed berries, clean musk",
                notes: {
                    top: ["Lavender", "Lemon", "Mint", "Basil"],
                    middle: ["Caramel", "Cinnamon", "Strawberry"],
                    base: ["Cedar", "Vetiver", "Amber", "Wood"],
                },
                occasions: ["All"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "All Seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/2f7c1bd0949d5c07ef88e64d4e0572f5.jpg?v=1756714911",
                link: "https://wanaromah.com/products/sweet-150",
            },
            {
                name: "Berry Vanilla Musk",
                code: "sweet-152",
                description: "Berries, vanilla, soft musk",
                notes: {
                    top: ["Big Strawberry"],
                    middle: ["Raspberry", "Apple"],
                    base: ["Sandalwood", "Strawberry"],
                },
                occasions: ["Sports"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/50c63c7c48d37404251e3511d71750f1.jpg?v=1756714911",
                link: "https://wanaromah.com/products/sweet-152",
            },
        ],
    },
    fresh: {
        name: "Fresh",
        products: [
            {
                name: "Spiced Bergamot Glow",
                code: "fresh-117",
                description: "A warm fusion of bergamot and spice",
                notes: {
                    top: ["Bergamot", "Lavender"],
                    middle: ["Sichuan Pepper", "Anise", "Nutmeg"],
                    base: ["Amber", "Vanilla"],
                },
                occasions: ["Casual"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Autumn/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fresh-117.jpg?v=1758281085",
                link: "https://wanaromah.com/products/fresh-117",
            },
            {
                name: "Green Tea Harmony",
                code: "fresh-118",
                description: "Refreshing green tea blended with citrus and musk",
                notes: {
                    top: ["Bergamot", "Mandarin Orange"],
                    middle: ["Green Tea", "Black Currant"],
                    base: ["Musk", "Petitgrain", "Sandalwood", "Galbanum"],
                },
                occasions: ["Special Occasion"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fresh-118.jpg?v=1758281086",
                link: "https://wanaromah.com/products/fresh-118",
            },

            {
                name: "Bright Citrus Burst",
                code: "fresh-124",
                description: "Lemon, bergamot, grapefruit",
                notes: {
                    top: ["Bergamot", "Lemon", "Lavender", "Verbena"],
                    middle: [
                        "Red Apple",
                        "Geranium",
                        "Rose",
                        "Coumarin",
                        "Oakmoss",
                    ],
                    base: ["Tonka Beans", "Sandalwood"],
                },
                occasions: ["Formal"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/5c222e5464dbf2adf2de2e9b67e79d9a.jpg?v=1756714911",
                link: "https://wanaromah.com/products/fresh-124",
            },
            {
                name: "Citrus Blossom Veil",
                code: "fresh-129",
                description: "Citrusy brightness balanced with soft florals",
                notes: {
                    top: ["Jasmine", "Bergamot", "Musk"],
                    middle: ["Vanilla", "Orange Blossom"],
                    base: ["Ambergris", "Musk"],
                },
                occasions: ["Special Occasion"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fresh-129.jpg?v=1758281085",
                link: "https://wanaromah.com/products/fresh-129",
            },

            {
                name: "Citrus Sunshine",
                code: "fresh-130",
                description: "Orange, lime, citrus zest",
                notes: {
                    top: ["Saffron", "Jasmine"],
                    middle: ["Amber", "Ambergris"],
                    base: ["Fir Resin", "Cedar"],
                },
                occasions: ["Sports"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/7a68d9546066ffb68b3d2665ac381409.jpg?v=1756714910",
                link: "https://wanaromah.com/products/fresh-130",
            }, {
                name: "Citrus Spice Fresh",
                code: "fresh-133",
                description: "Zesty citrus blended with aromatic spices",
                notes: {
                    top: ["Lavender", "Lemon", "Bergamot", "Mandarin Orange"],
                    middle: ["Sage", "Juniper Berries", "Basil", "Coriander"],
                    base: ["Sandalwood", "Vetiver", "Musk", "Amber", "Rosewood"],
                },
                occasions: ["All"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fresh-133.jpg?v=1758281085",
                link: "https://wanaromah.com/products/fresh-133",
            },

            {
                name: "Sparkling Citrus",
                code: "fresh-134",
                description: "Sparkling lemon, yuzu, mint",
                notes: {
                    top: ["Grapefruit", "Tangerine"],
                    middle: ["Pineapple", "Cedar"],
                    base: ["Amber", "Tonka Beans"],
                },
                occasions: ["Special Occasion"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/463f4915fc3a7bc410b195b5d425c708.jpg?v=1756714910",
                link: "https://wanaromah.com/products/fresh-134",
            },

            {
                name: "Citrus Tobacco Twist",
                code: "fresh-127",
                description: "A bold play of citrus, florals, and tobacco",
                notes: {
                    top: ["Neroli", "Apple", "Lemon", "Bergamot"],
                    middle: ["Rose", "Teakwood", "Patchouli"],
                    base: ["Vanilla", "Musk", "Tobacco"],
                },
                occasions: ["Sports"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Autumn/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fresh-127.jpg?v=1758281086",
                link: "https://wanaromah.com/products/fresh-127",
            },

            {
                name: "Green Clean Breeze",
                code: "fresh-120",
                description: "Mint, eucalyptus, green tea",
                notes: {
                    top: ["Bergamot", "Sea Notes", "Coriander"],
                    middle: ["Lavender", "Rosemary", "Geranium", "Neroli"],
                    base: ["Amber", "Musk", "Cedarwood", "Oakmoss"],
                },
                occasions: ["All"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/62262d9414fbbf36cbb7bcf039f2f24c.jpg?v=1756807855",
                link: "https://wanaromah.com/products/fresh-120",
            },
            {
                name: "Fresh Green Leaves",
                code: "fresh-125",
                description: "Green leaves, bamboo, dew",
                notes: {
                    top: ["Sea Water", "Lavender", "Mint", "Coriander"],
                    middle: ["Sandal", "Neroli", "Geranium", "Jasmine"],
                    base: ["Musk", "Tobacco", "Oakmoss", "Cedar", "Amber"],
                },
                occasions: ["Sports"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/73d4d85ffc5d24c1d4ad76db69a85241.jpg?v=1756714911",
                link: "https://wanaromah.com/products/fresh-125",
            },
            {
                name: "Clean Green Air",
                code: "fresh-128",
                description: "Clean air, green grass, ozone",
                notes: {
                    top: ["Musk", "Lime"],
                    middle: ["Herbal Notes"],
                    base: ["Amber", "Sandalwood", "Musk"],
                },
                occasions: ["Casual"],
                longevity: "6-8 hours",
                sillage: "Light to Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/16a45555b943a3de51991fb3245e42b9.jpg?v=1756714911",
                link: "https://wanaromah.com/products/fresh-128",
            },
            {
                name: "Aquatic Ocean Mist",
                code: "fresh-131",
                description: "Sea salt, marine accord, driftwood",
                notes: {
                    top: ["Musk", "Lily", "Galbanum", "Ylang-Ylang"],
                    middle: ["Musk", "Lily", "Rose"],
                    base: [
                        "Musk",
                        "Iris",
                        "Oakmoss",
                        "Peach",
                        "Amber",
                        "Vanilla",
                    ],
                },
                occasions: ["All"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/d21f708d91441b0f1b081f457486e55b.jpg?v=1756714911",
                link: "https://wanaromah.com/products/fresh-131",
            },
            {
                name: "Deep Ocean Breeze",
                code: "fresh-132",
                description: "Ocean breeze, seaweed, minerals",
                notes: {
                    top: ["Lemon", "Mint", "Rosemary", "Bergamot", "Basil"],
                    middle: ["Juniper", "Coriander", "Clove"],
                    base: ["Oakmoss", "Musk", "Patchouli", "Amber", "Resin"],
                },
                occasions: ["Formal"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/ea3527c0047505a768231ed301fac3fa.jpg?v=1756714911",
                link: "https://wanaromah.com/products/fresh-132",
            },
        ],

    }, spicy: {
        name: "Spicy",

        products: [
            {
                name: "Clove Pepper Heat",
                code: "spicy-171",
                description: "Black pepper, clove, cinnamon",
                notes: {
                    top: ["Bergamot", "Clove", "Lavender", "Lemon", "Basil"],
                    middle: ["Musk", "Juniper", "Coriander", "Cinnamon"],
                    base: [
                        "Cedarwood",
                        "Amber",
                        "Vetiver",
                        "Sandalwood",
                        "Resins",
                        "Oakmoss",
                        "Patchouli",
                    ],
                },
                occasions: ["All"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fb12b60a1bf48adcb7dfd5542c01a45f.jpg?v=1756714911",
                link: "https://wanaromah.com/products/spicy-171",
            }, {
                name: "Fiery Vetiver Spice",
                code: "spicy-172",
                description: "Vetiver with chilli heat and warm spices",
                notes: {
                    top: ["Pepper", "Labdanum"],
                    middle: ["Patchouli", "Rose", "Pepper"],
                    base: ["Benzoin", "Amber", "Vanilla", "Pink Pepper"],
                },
                occasions: ["Special Occasion"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-172_9a25ffa5-fd81-4f35-bdce-672e4289f953.jpg?v=1758281086",
                link: "https://wanaromah.com/products/spicy-172",
            },

            {
                name: "Peppery Spice Blend",
                code: "spicy-173",
                description: "Pink pepper, clove, nutmeg",
                notes: {
                    top: ["Clove", "Violet Leaf", "Labdanum"],
                    middle: ["Patchouli", "Pink Pepper", "Orange Blossom"],
                    base: ["Benzoin", "Amber", "Vanilla", "Musk"],
                },
                occasions: ["Casual"],
                longevity: "7-9 hours",
                sillage: "Moderate to Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/9801bd49465d4b4d148ae47cc41e61a6.jpg?v=1756714910",
                link: "https://wanaromah.com/products/spicy-173",
            },
            {
                name: "Spicy Pepper Fire",
                code: "spicy-174",
                description: "Hot pepper, clove, cardamom",
                notes: {
                    top: ["Nutmeg", "Pepper Berries"],
                    middle: ["Saffron", "Patchouli", "Woody Notes"],
                    base: ["Cumin", "Amber", "Juniper Berries", "Cedar"],
                },
                occasions: ["All"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/912936aee3717776bfaee4fe8e0e7dd2.jpg?v=1756714911",
                link: "https://wanaromah.com/products/spicy-174",
            },
            {
                name: "Cedar Clove Spice",
                code: "spicy-177",
                description: "Spicy clove balanced with woody cedar",
                notes: {
                    top: ["Bergamot", "Clove", "Lavender", "Lemon", "Basil"],
                    middle: ["Musk", "Juniper", "Coriander", "Cinnamon"],
                    base: ["Cedarwood", "Amber", "Vetiver", "Sandalwood", "Resins", "Oakmoss", "Patchouli"],
                },
                occasions: ["Special Occasion"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-177_c22e889f-5a7a-445d-9131-8e7e6701dcad.jpg?v=1758281085",
                link: "https://wanaromah.com/products/spicy-177",
            },
            {
                name: "Woody Cardamom Heat",
                code: "spicy-175",
                description: "Warm cardamom and woods with a fruity spark",
                notes: {
                    top: ["Pear", "Apple", "Grapefruit"],
                    middle: ["Rose", "Pink Pepper", "Cardamom"],
                    base: ["Cinnamon", "Sandalwood", "Musk"],
                },
                occasions: ["Casual"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Autumn/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-175_c01ed518-f810-4a78-b624-4bcf26a843f6.jpg?v=1758281085",
                link: "https://wanaromah.com/products/spicy-175",
            },
            {
                name: "Cedar Spiced Heat",
                code: "spicy-178",
                description: "Zesty pepper with warm woody cedar",
                notes: {
                    top: ["Bergamot", "Pepper"],
                    middle: ["Lavender", "Sichuan Pepper", "Anise", "Nutmeg"],
                    base: ["Amber", "Cedar", "Labdanum"],
                },
                occasions: ["Sports"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Autumn/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-178_6f209d9f-36c6-415c-9d0b-30eb4937798d.jpg?v=1758281086",
                link: "https://wanaromah.com/products/spicy-178",
            },
            {
                name: "Woody Spice Blend",
                code: "spicy-180",
                description: "Cardamom, cedar, nutmeg",
                notes: {
                    top: ["Lavender", "Amalfi Lemon", "Bergamot"],
                    middle: ["Thyme", "Sage", "Pink Pepper", "Cinnamon"],
                    base: ["Tobacco", "Vetiver", "Patchouli"],
                },
                occasions: ["Formal"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/74ddc8f0ded24489aecbe13eb8a19d68.jpg?v=1756714911",
                link: "https://wanaromah.com/products/spicy-180",
            },
            {
                name: "Spiced Woods",
                code: "spicy-184",
                description: "Spiced woods, sandalwood, amber",
                notes: {
                    top: ["Apple", "Lemon", "Plum", "Cinnamon"],
                    middle: ["Cinnamon", "Mahogany", "Oakmoss"],
                    base: ["Vanilla", "Sandalwood", "Vetiver", "Tobacco"],
                },
                occasions: ["Formal"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/dfc2a5c42262f5428114f8928d36c696.jpg?v=1756714911",
                link: "https://wanaromah.com/products/spicy-184",
            },
            {
                name: "Leather Smoke Mystery",
                code: "spicy-179",
                description: "Smoky leather, tobacco, spices",
                notes: {
                    top: ["Nutmeg Flower", "Cedar", "Chamomile", "Hawthorn"],
                    middle: ["Nutmeg", "Sandalwood", "Honeysuckle"],
                    base: ["Leather", "Tonka Beans", "Vetiver", "Patchouli"],
                },
                occasions: ["Casual"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/caf0afb3b00ee373e8ad476204b2b8c3.jpg?v=1756714911",
                link: "https://wanaromah.com/products/spicy-179",
            },
            {
                name: "Smoky Leather Blend",
                code: "spicy-181",
                description: "Leather, smoke, dark spices",
                notes: {
                    top: ["Basil", "Galbanum", "Nutmeg Flower", "Artemisia"],
                    middle: [
                        "Pine Tree Needles",
                        "Nutmeg",
                        "Patchouli",
                        "Spices",
                        "Vetiver",
                    ],
                    base: [
                        "Leather",
                        "Benzoin",
                        "Coconut",
                        "Tonka Beans",
                        "Amber",
                        "Vanilla",
                        "Sandalwood",
                    ],
                },
                occasions: ["Sports"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/004f82da822a34ce2bc697ba404dab79.jpg?v=1756714911",
                link: "https://wanaromah.com/products/spicy-181",
            },
            {
                name: "Patchouli Pepper Blend",
                code: "spicy-183",
                description: "Patchouli layered with pepper and woody musk",
                notes: {
                    top: ["Nutmeg", "Pink Pepper", "Bergamot"],
                    middle: ["Patchouli", "Cedar", "Sandalwood"],
                    base: ["Civette", "Amber", "Musk", "Oakmoss"],
                },
                occasions: ["All"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Autumn/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-183_c46e7814-e3c5-45d3-9e5f-7937aafc3a86.jpg?v=1758281086",
                link: "https://wanaromah.com/products/spicy-183",
            },

            {
                name: "Chilli Citrus Zest",
                code: "spicy-176",
                description: "Bright citrus infused with chilli and spice",
                notes: {
                    top: ["Chilli", "Bergamot"],
                    middle: ["Ginger", "Vetiver"],
                    base: ["Vetiver", "Cypress", "Laurel", "Chilli Berry"],
                },
                occasions: ["Sports"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-176_3b249775-6edc-4ec2-9f5e-6d01ede8f5c5.jpg?v=1758281086",
                link: "https://wanaromah.com/products/spicy-176",
            },
            {
                name: "Basil Musk Fusion",
                code: "spicy-182",
                description: "Aromatic basil blended with spiced musk",
                notes: {
                    top: ["Lavender", "Anise", "Basil", "Lemon"],
                    middle: ["Ylang-Ylang", "Geranium", "Nutmeg"],
                    base: ["Coumarin", "Musk", "Sandalwood", "Tonka Beans", "Vetiver", "Patchouli", "Vanilla"],
                },
                occasions: ["Formal"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Autumn/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-182_7dab2d10-d734-4908-bc94-1cb8a8e209d3.jpg?v=1758281085",
                link: "https://wanaromah.com/products/spicy-182",
            },
            {
                name: "Ginger Smoke Incense",
                code: "spicy-185",
                description: "Zesty ginger with smoky incense and spice",
                notes: {
                    top: ["Ginger", "Lemon", "Mint"],
                    middle: ["Nutmeg", "Pink Pepper", "Ginger"],
                    base: ["Patchouli", "Incense", "Cedar"],
                },
                occasions: ["Casual"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-185_3ad4eff9-e7b0-44ac-9584-619ac856f556.jpg?v=1758281086",
                link: "https://wanaromah.com/products/spicy-185",
            },


            {
                name: "Fresh Spice Garden",
                code: "spicy-186",
                description: "Basil, mint, pink pepper",
                notes: {
                    top: ["Peppermint", "Bergamot"],
                    middle: ["Mint", "Vetiver", "Lemon"],
                    base: ["Cinnamon", "Musk", "Sandalwood"],
                },
                occasions: ["Sports"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/4022d4c054286d625305440962a03dec.jpg?v=1756714911",
                link: "https://wanaromah.com/products/spicy-186",
            },
            {
                name: "Minty Spice Blend",
                code: "spicy-187",
                description: "Mint, basil, green cardamom",
                notes: {
                    top: ["Peppermint", "Anise", "Basil"],
                    middle: ["Lavender", "Bergamot"],
                    base: ["Sandalwood", "Vanilla", "Musk"],
                },
                occasions: ["Special Occasion"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/bfbe3520e7b297edc8069765d3a4ef43.jpg?v=1756807854",
                link: "https://wanaromah.com/products/spicy-187",
            },
            {
                name: "Herbal Spice Fresh",
                code: "spicy-188",
                description: "Fresh herbs, spices, mint",
                notes: {
                    top: ["Mint", "Lemon", "Rosemary"],
                    middle: ["Musk", "Cinnamon", "Juniper"],
                    base: ["Musk"],
                },
                occasions: ["All"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "All Seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/8802a457a91d87141e17cb3f6016eaea.jpg?v=1756810438",
                link: "https://wanaromah.com/products/spicy-188",
            },
        ]

    },
    "healing-note": {
        name: "Healing Notes",
        products: [
            {
                name: "Mullai",
                code: "mullai",
                description: "Sweet floral",
                benefit: "REDUCE STRESS",
                notes: {
                    top: ["Sweet Jasmine", "White Flowers"],
                    middle: ["Mullai Blossoms", "Green Leaves"],
                    base: ["Soft Musk", "Woody Notes"]
                },
                occasions: ["Meditation", "Relaxation", "Evening wear", "Self-care"],
                longevity: "4-6 hours",
                sillage: "Soft",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/mullai.webp?v=1759753704"
            },
            {
                name: "Thazhampoo",
                code: "thazhampoo",
                description: "Spicy floral",
                benefit: "GOOD FOR SPIRITUALITY",
                notes: {
                    top: ["Spiced Florals", "Clove"],
                    middle: ["Magnolia", "Temple Flowers"],
                    base: ["Incense", "Sandalwood", "Amber"]
                },
                occasions: ["Meditation", "Prayer", "Spiritual practices", "Temple visits"],
                longevity: "5-7 hours",
                sillage: "Moderate",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Thazhampoo.jpg?v=1759753705"
            },
            {
                name: "Pitchipoo",
                code: "pitchipoo",
                description: "Floral & musky",
                benefit: "ENERGIZES THE MOOD",
                notes: {
                    top: ["Fresh Florals", "Citrus"],
                    middle: ["Jasmine", "White Flowers"],
                    base: ["Musk", "Amber", "Soft Woods"]
                },
                occasions: ["Morning wear", "Work", "Active days", "Social gatherings"],
                longevity: "4-6 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Pitchipoo.webp?v=1759753704"
            },
            {
                name: "Marikolundhu",
                code: "marikolundhu",
                description: "Citrus & floral",
                benefit: "IMPROVES SLEEP",
                notes: {
                    top: ["Bergamot", "Lemon", "Orange Blossom"],
                    middle: ["Lavender", "Chamomile"],
                    base: ["Soft Musk", "Vanilla", "Sandalwood"]
                },
                occasions: ["Bedtime", "Evening relaxation", "Stress relief", "Home wear"],
                longevity: "4-6 hours",
                sillage: "Soft",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Marikolundhu_0b114d36-1505-49ab-8f43-aeffd59e12f0.png?v=1759753706"
            },
            {
                name: "Mogra",
                code: "mogra",
                description: "Green floral",
                benefit: "CALMS THE MIND",
                notes: {
                    top: ["Green Leaves", "Fresh Jasmine"],
                    middle: ["Mogra Flowers", "White Florals"],
                    base: ["Soft Musk", "Cedarwood"]
                },
                occasions: ["Meditation", "Yoga", "Evening wear", "Relaxation"],
                longevity: "5-7 hours",
                sillage: "Soft to Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Mogra.jpg?v=1759753704"
            },
            {
                name: "Sampangi",
                code: "sampangi",
                description: "Fruity & floral",
                benefit: "REDUCE TENSION",
                notes: {
                    top: ["Peach", "Apricot", "Citrus"],
                    middle: ["Champaca", "Orange Blossom"],
                    base: ["Sandalwood", "Musk", "Vanilla"]
                },
                occasions: ["Daytime wear", "Stress relief", "Social events", "Casual outings"],
                longevity: "5-7 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Sampangi.jpg?v=1759753703"
            },
            {
                name: "Tube Rose",
                code: "tube rose",
                description: "Earthy floral",
                benefit: "AIDS SLEEP",
                notes: {
                    top: ["Green Notes", "Bergamot"],
                    middle: ["Tuberose", "Jasmine"],
                    base: ["Earthy Musk", "Sandalwood", "Amber"]
                },
                occasions: ["Bedtime", "Evening relaxation", "Meditation", "Calm moments"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Tube_Rose.jpg?v=1759753704"
            },
            {
                name: "Night Queen",
                code: "night queen",
                description: "Floral sweet",
                benefit: "ANXIETY RELIEVER",
                notes: {
                    top: ["Sweet Florals", "Honeysuckle"],
                    middle: ["Night Blooming Jasmine", "Gardenia"],
                    base: ["Vanilla", "Musk", "Amber"]
                },
                occasions: ["Evening wear", "Stress relief", "Romantic evenings", "Relaxation"],
                longevity: "5-7 hours",
                sillage: "Moderate",
                season: "Summer/Fall",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Night_Queen.jpg?v=1759753704"
            },
            {
                name: "Ylang Ylang",
                code: "ylang ylang",
                description: "Fruity & spice",
                benefit: "AIDS SLEEP",
                notes: {
                    top: ["Banana", "Neroli", "Bergamot"],
                    middle: ["Ylang Ylang", "Jasmine", "Spices"],
                    base: ["Vanilla", "Sandalwood", "Musk"]
                },
                occasions: ["Bedtime", "Meditation", "Evening wear", "Spa days"],
                longevity: "6-8 hours",
                sillage: "Moderate to Strong",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Ylang_Ylang.jpg?v=1759753704"
            },
            {
                name: "Pahadi",
                code: "pahadi",
                description: "Floral & earthy",
                benefit: "CALMING",
                notes: {
                    top: ["Mountain Flowers", "Fresh Air"],
                    middle: ["Wild Herbs", "Lavender"],
                    base: ["Earth", "Moss", "Cedarwood"]
                },
                occasions: ["Meditation", "Yoga", "Nature walks", "Stress relief"],
                longevity: "4-6 hours",
                sillage: "Soft",
                season: "Spring/Fall",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Pahadi.jpg?v=1759753703"
            },
            {
                name: "Rajinigantha",
                code: "rajinigantha",
                description: "Floral & vetiver",
                benefit: "RELAXATION",
                notes: {
                    top: ["White Flowers", "Green Leaves"],
                    middle: ["Tuberose", "Jasmine"],
                    base: ["Vetiver", "Sandalwood", "Musk"]
                },
                occasions: ["Evening wear", "Meditation", "Stress relief", "Calm moments"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Rajinigantha.jpg?v=1759753704"
            },
            {
                name: "Rose",
                code: "rose",
                description: "Floral & warm spice",
                benefit: "IMPROVES BRAIN HEALTH",
                notes: {
                    top: ["Rose Petals", "Bergamot"],
                    middle: ["Bulgarian Rose", "Geranium", "Cinnamon"],
                    base: ["Amber", "Sandalwood", "Musk"]
                },
                occasions: ["Daytime wear", "Focus work", "Study sessions", "All occasions"],
                longevity: "5-7 hours",
                sillage: "Moderate",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/rose.jpg?v=1759753704"
            }
        ]
    },    "divine-note": {
        name: "Divine Notes",
        products: [
            {
                name: "Jawwad",
                code: "jawwad",
                description: "Civet & amber",
                notes: {
                    top: ["Saffron", "Rose"],
                    middle: ["Civet", "Amber"],
                    base: ["Benzoin", "Musk", "Agarwood"]
                },
                occasions: ["Special occasions", "Evening wear", "Cultural events", "Celebrations"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Jawwad.jpg?v=1759753725"
            },
            {
                name: "Jawwad Amrut",
                code: "jawwad amrut",
                description: "Civet, amber & honey",
                notes: {
                    top: ["Honey", "Nutmeg", "Saffron"],
                    middle: ["Civet", "Patchouli", "Rose"],
                    base: ["Amber", "Labdanum", "Benzoin"]
                },
                occasions: ["Special occasions", "Evening wear", "Weddings", "Formal events"],
                longevity: "10-12 hours",
                sillage: "Very Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Amrut.jpg?v=1759753724"
            },
            {
                name: "Majmua",
                code: "majmua",
                description: "Rose, amber & wood",
                notes: {
                    top: ["Saffron", "White Rose", "Bergamot"],
                    middle: ["Amber", "Bulgarian Rose", "Patchouli"],
                    base: ["Sandalwood", "Mixed Woods", "Vetiver"]
                },
                occasions: ["Special occasions", "Prayer", "Cultural events", "Evening wear"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/067b0e2fdb238975d6567015ae713ec0.jpg?v=1756711135"
            },
            {
                name: "Jannat Ul Firdaus",
                code: "jannat ul firdaus",
                description: "Rose, herbal & spice",
                notes: {
                    top: ["Herbal Notes", "Grass", "Citrus"],
                    middle: ["Rose", "Cinnamon", "Lotus", "Tea"],
                    base: ["Woody Notes", "Jasmine", "Musk"]
                },
                occasions: ["Special occasions", "Prayer", "Spiritual events", "Evening wear"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Jannat_Ul_Firdaus.jpg?v=1759753723"
            }
        ]
    }
}

var allproduct = [
    {
        name: "Oud Amber Glow",
        code: "lxe-1008",
        description: "Bulgarian rose, oud, amber",
        notes: {
            top: ["Bulgarian Rose", "Bergamot"],
            middle: ["Oud Wood", "Rose Petals"],
            base: ["Amber", "Sandalwood", "Musk"],
        },
        occasions: [
            "Evening wear",
            "Special occasions",
            "Date nights",
            "Formal events",
        ],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Fall/Winter",

        vid: "https://www.youtube.com/watch?v=example1",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/067b0e2fdb238975d6567015ae713ec0.jpg?v=1756711135"
    },
    {
        name: "Petrichor Vetiver",
        code: "lxe-1011",
        description: "Rain-kissed vetiver & woods",
        notes: {
            top: ["Wet Earth", "Green Leaves"],
            middle: ["Vetiver", "Cedarwood"],
            base: ["Sandalwood", "Moss", "Amber"],
        },
        occasions: [
            "Casual wear",
            "Office",
            "Outdoor activities",
            "Meditation",
        ],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Fall",

        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/84a7160bb120b094d64514271e5a6c54.jpg?v=1756711135"
    },
    {
        name: "Burnt Rose & Agarwood",
        code: "lxe-1016",
        description: "Saffron incense & oud",
        notes: {
            top: ["Saffron", "Rose Petals"],
            middle: ["Agarwood", "Incense"],
            base: ["Amber", "Sandalwood", "Musk"],
        },
        occasions: [
            "Evening wear",
            "Cultural events",
            "Meditation",
            "Special ceremonies",
        ],
        longevity: "10-12 hours",
        sillage: "Very Strong",
        season: "Fall/Winter",

        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/9b184766ecb17ab23661259786411b12.jpg?v=1756711135"
    },
    {
        name: "Animalic Agarwood",
        code: "lxe-1031",
        description: "Wild oud & civet amber",
        notes: {
            top: ["Wild Herbs", "Spices"],
            middle: ["Agarwood", "Civet"],
            base: ["Amber", "Animalic Musk", "Leather"],
        },
        occasions: [
            "Evening wear",
            "Confidence boost",
            "Special occasions",
            "Cold weather",
        ],
        longevity: "12+ hours",
        sillage: "Very Strong",
        season: "Fall/Winter",

        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/815fcdb2b4d4b4128ab517b630940989.jpg?v=1756807854"
    },
    {
        name: "Warm Spicy Aura",
        code: "lxe-1038",
        description: "Cardamom, violet, patchouli",
        notes: {
            top: ["Cardamom", "Pink Pepper"],
            middle: ["Violet", "Rose"],
            base: ["Patchouli", "Sandalwood", "Amber"],
        },
        occasions: [
            "Evening wear",
            "Date nights",
            "Cooler weather",
            "Artistic events",
        ],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Fall/Winter",

        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/111b6360357314803b93a8b43accafe5.jpg?v=1756711135"
    },
    {
        name: "Burnt Sugar & Amber",
        code: "lxe-1022",
        description: "Saffron sugar, sandal, ambergris",
        notes: {
            top: ["Saffron", "Caramelized Sugar"],
            middle: ["Sandalwood", "Rose"],
            base: ["Ambergris", "Vanilla", "Musk"],
        },
        occasions: [
            "Evening wear",
            "Romantic dinners",
            "Special occasions",
            "Cold weather",
        ],
        longevity: "10-12 hours",
        sillage: "Strong",
        season: "Fall/Winter",

        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/8655d3e919a25137ce161e327046646d.jpg?v=1756711135"
    },

    {
        name: "Burnt Vanilla Sugarcane",
        code: "lxe-1009",
        description: "Burnt sugar, vanilla, tobacco",
        notes: {
            top: ["Burnt Sugar", "Caramel"],
            middle: ["Madagascar Vanilla", "Tobacco Leaf"],
            base: ["Amber", "Sandalwood", "Musk"],
        },
        occasions: [
            "Evening wear",
            "Date nights",
            "Cozy gatherings",
            "Cold weather",
        ],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Fall/Winter",

        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/bedf0b3ba60a595a4f084fd5c94a5442.jpg?v=1756711136"
    },
    {
        name: "Burnt Vanilla & Coffee",
        code: "lxe-1030",
        description: "Warm vanilla, deep musk, coffee",
        notes: {
            top: ["Coffee Bean", "Cardamom"],
            middle: ["Vanilla", "Caramel"],
            base: ["Deep Musk", "Sandalwood", "Amber"],
        },
        occasions: [
            "Morning wear",
            "Office",
            "Casual outings",
            "Coffee dates",
        ],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Fall/Winter",

        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/b860f8da5c8c8a92a0180cc07c2f24c8.jpg?v=1756711135"
    },
    {
        name: "Mango Almond Silk",
        code: "lxe-1018",
        description: "Almond cream, mango, sandalwood",
        notes: {
            top: ["Mango", "Bergamot"],
            middle: ["Almond Cream", "Coconut"],
            base: ["Sandalwood", "Vanilla", "White Musk"],
        },
        occasions: [
            "Summer evenings",
            "Tropical vacations",
            "Romantic dinners",
            "Special occasions",
        ],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",

        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/6f558209bca8c009629e9ebb40fa8633.jpg?v=1756711135"
    },
    {
        name: "Sweet Fresh Champagne",
        code: "lxe-1035",
        description: "Quince, freesia, almond musk",
        notes: {
            top: ["Quince", "Pear", "Sparkling Notes"],
            middle: ["Freesia", "Lily of the Valley"],
            base: ["Almond Musk", "Vanilla", "Sandalwood"],
        },
        occasions: [
            "Celebrations",
            "Daytime events",
            "Spring outings",
            "Brunch dates",
        ],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",

        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/48200636f966493b835b3e3f3bf7bd64.jpg?v=1756711136"
    },
    {
        name: "Sweet Citrus Glow",
        code: "lxe-1037",
        description: "Tangerine, green apple, vanilla",
        notes: {
            top: ["Tangerine", "Green Apple", "Lemon"],
            middle: ["Orange Blossom", "Peach"],
            base: ["Vanilla", "White Musk", "Cedarwood"],
        },
        occasions: [
            "Daytime wear",
            "Casual outings",
            "Work",
            "Spring activities",
        ],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",

        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/584f9d1204cbb93779eeadcc1f51c84f.jpg?v=1756711136"
    },
    {
        name: "Green Vanilla Veil",
        code: "lxe-1036",
        description: "Lemon, mint, tonka, Madagascar vanilla",
        notes: {
            top: ["Lemon", "Mint", "Green Leaves"],
            middle: ["Tonka Bean", "Coconut"],
            base: ["Madagascar Vanilla", "Sandalwood", "Musk"],
        },
        occasions: [
            "Daytime wear",
            "Spring outings",
            "Casual events",
            "Fresh starts",
        ],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",

        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/0036e24b3412ba80e3e24cc3020a1bab.jpg?v=1756711135"
    },

    {
        name: "Sandal Green Amber",
        code: "lxe-1012",
        description: "Green citrus, sandal, cedar",
        notes: {
            top: ["Green Citrus", "Bergamot", "Lime"],
            middle: ["Sandalwood", "Geranium"],
            base: ["Cedar", "Amber", "White Musk"],
        },
        occasions: [
            "Daytime wear",
            "Office",
            "Casual outings",
            "Spring activities",
        ],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",

        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fa8115a116bd1d72193cb6d7d0de9404.jpg?v=1756711136"
    },
    {
        name: "Citrus & Warm Spice",
        code: "lxe-1014",
        description: "Cinnamon, nutmeg, lavender woods",
        notes: {
            top: ["Cinnamon", "Nutmeg", "Orange"],
            middle: ["Lavender", "Geranium"],
            base: ["Sandalwood", "Cedar", "Amber"],
        },
        occasions: [
            "Daytime wear",
            "Autumn walks",
            "Cozy gatherings",
            "Weekend activities",
        ],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Fall/Spring",

        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/2120186066c813757ae4661e6a763e48.jpg?v=1756807853"
    },
    {
        name: "Sea Salt & Tobacco",
        code: "lxe-1032",
        description: "Marine air, orchid, incense",
        notes: {
            top: ["Sea Salt", "Marine Air", "Ozone"],
            middle: ["Orchid", "Tobacco Leaf"],
            base: ["Incense", "Driftwood", "Amber"],
        },
        occasions: [
            "Evening wear",
            "Meditation",
            "Coastal walks",
            "Artistic events",
        ],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Spring/Summer",

        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/dfcf26d5444e1900486f42e7a948b537.jpg?v=1756711136"
    },
    {
        name: "Dark Tobacco Essence",
        code: "oriental-107",
        description: "Dark tobacco, leather, amber",
        notes: {
            top: ["Black Pepper", "Bergamot"],
            middle: ["Dark Tobacco", "Leather"],
            base: ["Amber", "Sandalwood", "Musk"],
        },
        occasions: [
            "Evening wear",
            "Business meetings",
            "Cold weather",
            "Formal events",
        ],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/16c856b316b44f7c630e0879f7f5f220.jpg?v=1756711777",
        link: "https://wanaromah.com/products/oriental-107",
    },
    {
        name: "Smoky Oud Mystery",
        code: "oriental-110",
        description: "Smoky oud, incense, vanilla",
        notes: {
            top: ["Incense", "Saffron"],
            middle: ["Smoky Oud", "Rose"],
            base: ["Vanilla", "Amber", "Sandalwood"],
        },
        occasions: [
            "Evening wear",
            "Meditation",
            "Special occasions",
            "Cultural events",
        ],
        longevity: "10-12 hours",
        sillage: "Very Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/05d0d1ba3e1df524644df3c06a249d84.jpg?v=1756711777",
        link: "https://wanaromah.com/products/oriental-110",
    },
    {
        name: "Leather & Smoke",
        code: "oriental-116",
        description: "Leather, smoke, dark woods",
        notes: {
            top: ["Smoke", "Black Pepper"],
            middle: ["Leather", "Dark Woods"],
            base: ["Sandalwood", "Amber", "Musk"],
        },
        occasions: [
            "Evening wear",
            "Business meetings",
            "Formal events",
            "Winter wear",
        ],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/af2ba6e737f5a50b50bd8f5ad485ed0c.jpg?v=1756711777",
        link: "https://wanaromah.com/products/oriental-116",
    },
    {
        name: "Frankincense Dreams",
        code: "oriental-099",
        description: "Frankincense, myrrh, sandalwood",
        notes: {
            top: ["Frankincense", "Bergamot"],
            middle: ["Myrrh", "Rose"],
            base: ["Sandalwood", "Amber", "Musk"],
        },
        occasions: [
            "Meditation",
            "Evening wear",
            "Spiritual events",
            "Cold weather",
        ],
        longevity: "10-12 hours",
        sillage: "Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/a076331b4f164006901184c6ed2c1912.jpg?v=1756711778",
        link: "https://wanaromah.com/products/oriental-099",
    },
    {
        name: "Amber Resin Glow",
        code: "oriental-101",
        description: "Amber resin, benzoin, vanilla",
        notes: {
            top: ["Bergamot", "Orange"],
            middle: ["Amber Resin", "Benzoin"],
            base: ["Vanilla", "Sandalwood", "Musk"],
        },
        occasions: [
            "Evening wear",
            "Date nights",
            "Cozy gatherings",
            "Cold weather",
        ],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/7d06fae0a44c69522d28f8864f5edbbc.jpg?v=1756711778",
        link: "https://wanaromah.com/products/oriental-101",
    },
    {
        name: "Rich Oud Blend",
        code: "oriental-111",
        description: "Rich oud, amber, spices",
        notes: {
            top: ["Saffron", "Cardamom"],
            middle: ["Rich Oud", "Rose"],
            base: ["Amber", "Sandalwood", "Musk"],
        },
        occasions: [
            "Special occasions",
            "Evening wear",
            "Celebrations",
            "Formal events",
        ],
        longevity: "12+ hours",
        sillage: "Very Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/95af9f0fc9dde2ec00c662b37ba4bef4.jpg?v=1756711778",
        link: "https://wanaromah.com/products/oriental-111",
    },
    {
        name: "Oriental Mystique",
        code: "oriental-105",
        description: "Oriental spices, amber, sandalwood",
        notes: {
            top: ["Cardamom", "Cinnamon"],
            middle: ["Oriental Spices", "Amber"],
            base: ["Sandalwood", "Musk", "Vanilla"],
        },
        occasions: [
            "Evening wear",
            "Cultural events",
            "Special occasions",
            "Cold weather",
        ],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/2c7685114d4a7770e9a2b2545526703a.jpg?v=1756711778",
        link: "https://wanaromah.com/products/oriental-105",
    },
    {
        name: "Oriental Harmony",
        code: "oriental-112",
        description: "Balanced oriental blend, amber, woods",
        notes: {
            top: ["Bergamot", "Spices"],
            middle: ["Oriental Blend", "Amber"],
            base: ["Woods", "Sandalwood", "Musk"],
        },
        occasions: [
            "All occasions",
            "Business",
            "Evening wear",
            "Formal events",
        ],
        longevity: "8-10 hours",
        sillage: "Moderate to Strong",
        season: "All seasons",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/d017d548dbec0adfaa05e8d164ca1c65.jpg?v=1756711777",
        link: "https://wanaromah.com/products/oriental-112",
    },
    {
        name: "Oriental Luxury",
        code: "oriental-115",
        description:
            "Luxury oriental spices, gold amber, precious woods",
        notes: {
            top: ["Saffron", "Cardamom"],
            middle: ["Luxury Spices", "Gold Amber"],
            base: ["Precious Woods", "Oud", "Musk"],
        },
        occasions: [
            "Luxury events",
            "Special occasions",
            "VIP gatherings",
            "Formal ceremonies",
        ],
        longevity: "10-12 hours",
        sillage: "Very Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/303e3cf402f15fdbea3aa23724dbc1a7.jpg?v=1756711777",
        link: "https://wanaromah.com/products/oriental-115",
    },
    {
        name: "Rose Oud Harmony",
        code: "oriental-108",
        description: "Rose, oud, jasmine",
        notes: {
            top: ["Rose", "Bergamot"],
            middle: ["Oud", "Jasmine"],
            base: ["Sandalwood", "Amber", "Musk"],
        },
        occasions: [
            "Evening wear",
            "Date nights",
            "Romantic dinners",
            "Special occasions",
        ],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "All seasons",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/888b25797840e649143cfa8969359e0e.jpg?v=1756711778",
        link: "https://wanaromah.com/products/oriental-108",
    },
    {
        name: "Jasmine Oud Dream",
        code: "oriental-113",
        description: "Jasmine, oud, sandalwood",
        notes: {
            top: ["Jasmine", "Bergamot"],
            middle: ["Oud", "Rose"],
            base: ["Sandalwood", "Amber", "Musk"],
        },
        occasions: [
            "Evening wear",
            "Romantic occasions",
            "Cultural events",
            "Special dinners",
        ],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Spring/Fall",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/4ff1da6570a15c78a554d2462b676f85.jpg?v=1756711778",
        link: "https://wanaromah.com/products/oriental-113",
    },
    {
        name: "Vanilla Tobacco Dream",
        code: "oriental-109",
        description: "Vanilla tobacco, warm amber",
        notes: {
            top: ["Bergamot", "Spices"],
            middle: ["Vanilla Tobacco", "Honey"],
            base: ["Warm Amber", "Sandalwood", "Musk"],
        },
        occasions: [
            "Evening wear",
            "Cozy gatherings",
            "Date nights",
            "Cold weather",
        ],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/03eea0ea321794d3011881bff3d94d1b.jpg?v=1756711778",
        link: "https://wanaromah.com/products/oriental-109",
    },
    {
        name: "Amber Tobacco Blend",
        code: "oriental-114",
        description: "Amber, tobacco leaf, honey",
        notes: {
            top: ["Honey", "Bergamot"],
            middle: ["Tobacco Leaf", "Spices"],
            base: ["Amber", "Sandalwood", "Vanilla"],
        },
        occasions: [
            "Evening wear",
            "Autumn activities",
            "Cozy settings",
            "Special occasions",
        ],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/1f3b3a5a5ebfd7bfb5297102a9a47b6f.jpg?v=1756711777",
        link: "https://wanaromah.com/products/oriental-114",
    },

    {
        name: "Rose Garden Romance",
        code: "floral-159",
        description: "Red rose, peony, rose water",
        notes: {
            top: ["Rose Water", "Bergamot"],
            middle: ["Red Rose", "Peony"],
            base: ["Sandalwood", "Musk", "Amber"],
        },
        occasions: [
            "Date nights",
            "Romantic dinners",
            "Spring events",
            "Wedding occasions",
        ],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/8cf0f2b7a46ea55ec76f15ec443666e2.jpg?v=1756714910",
        link: "https://wanaromah.com/products/floral-159",
    },
    {
        name: "Bulgarian Rose Essence",
        code: "floral-170",
        description: "Bulgarian rose, damask rose, musk",
        notes: {
            top: ["Bulgarian Rose", "Lemon"],
            middle: ["Damask Rose", "Geranium"],
            base: ["White Musk", "Sandalwood", "Amber"],
        },
        occasions: [
            "Special occasions",
            "Evening wear",
            "Formal events",
            "Romantic settings",
        ],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "All seasons",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/8e47d0bd73dafa1d339cb2b2b13c2b7e.jpg?v=1756714911",
        link: "https://wanaromah.com/products/floral-188",
    },
    {
        name: "Rose Petals Dream",
        code: "floral-166",
        description: "Rose petals, vanilla, sandalwood",
        notes: {
            top: ["Rose Petals", "Bergamot"],
            middle: ["Rose", "Jasmine"],
            base: ["Vanilla", "Sandalwood", "Musk"],
        },
        occasions: [
            "Evening wear",
            "Cozy gatherings",
            "Date nights",
            "Self-care moments",
        ],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fdb4a770776a2cdbd74847f412764ae7.jpg?v=1756714910",
        link: "https://wanaromah.com/products/floral-191",
    },
    {
        name: "White Floral Bouquet",
        code: "floral-154",
        description: "Tuberose, gardenia, lily",
        notes: {
            top: ["Lily", "Bergamot"],
            middle: ["Tuberose", "Gardenia"],
            base: ["Sandalwood", "Musk", "Amber"],
        },
        occasions: [
            "Evening wear",
            "Special occasions",
            "Formal events",
            "Wedding celebrations",
        ],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/80f4728c79eb197fb265d1ad810bf8f7.jpg?v=1756714910",
        link: "https://wanaromah.com/products/floral-154",
    },
    {
        name: "Tuberose Night",
        code: "floral-163",
        description: "Tuberose, jasmine, white musk",
        notes: {
            top: ["Tuberose", "Bergamot"],
            middle: ["Jasmine", "White Florals"],
            base: ["White Musk", "Sandalwood", "Amber"],
        },
        occasions: [
            "Evening wear",
            "Date nights",
            "Romantic occasions",
            "Night events",
        ],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/4125fbadf2a65c4158c460d8bc567646.jpg?v=1756807854",
        link: "https://wanaromah.com/products/floral-194",
    },
    {
        name: "Gardenia Dreams",
        code: "floral-165",
        description: "Gardenia, magnolia, cream",
        notes: {
            top: ["Gardenia", "Bergamot"],
            middle: ["Magnolia", "White Florals"],
            base: ["Cream", "Sandalwood", "Musk"],
        },
        occasions: [
            "Daytime wear",
            "Spring events",
            "Romantic settings",
            "Garden parties",
        ],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/6b37a6814550576bdf4eac3d7e64cb85.jpg?v=1756714911",
        link: "https://wanaromah.com/products/floral-165",
    },
    {
        name: "Peach Blossom Joy",
        code: "floral-161",
        description: "Peach blossom, cherry, magnolia",
        notes: {
            top: ["Peach Blossom", "Bergamot"],
            middle: ["Cherry", "Magnolia"],
            base: ["Sandalwood", "Musk", "Vanilla"],
        },
        occasions: [
            "Daytime wear",
            "Spring events",
            "Casual outings",
            "Cheerful moments",
        ],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/e50f16274de41d49a5ecf9659a57eb57.jpg?v=1756714911",
        link: "https://wanaromah.com/products/floral-161",
    },
    {
        name: "Fruity Floral Fusion",
        code: "floral-164",
        description: "Pear, freesia, white florals",
        notes: {
            top: ["Pear", "Bergamot"],
            middle: ["Freesia", "White Florals"],
            base: ["White Musk", "Sandalwood", "Amber"],
        },
        occasions: [
            "Daytime wear",
            "Office",
            "Casual elegance",
            "Spring activities",
        ],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/891bf04e632aea9a9c356ed640dee81c.jpg?v=1756807855",
        link: "https://wanaromah.com/products/floral-193",
    },
    {
        name: "Berry Blossom",
        code: "floral-168",
        description: "Berry, cherry blossom, musk",
        notes: {
            top: ["Berry", "Bergamot"],
            middle: ["Cherry Blossom", "Florals"],
            base: ["Clean Musk", "Sandalwood", "Vanilla"],
        },
        occasions: [
            "Daytime wear",
            "Casual outings",
            "Spring events",
            "Youthful moments",
        ],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/f34ce2ecfd6605a86cafce001d8ed2f2.jpg?v=1756714911",
        link: "https://wanaromah.com/products/floral-189",
    },
    {
        name: "Oceanic Floral Breeze",
        code: "floral-158",
        description: "Sea lily, salt air, driftwood",
        notes: {
            top: ["Sea Lily", "Salt Air"],
            middle: ["Marine Florals", "Seaweed"],
            base: ["Driftwood", "Musk", "Amber"],
        },
        occasions: [
            "Daytime wear",
            "Beach activities",
            "Summer events",
            "Fresh moments",
        ],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/3ed3ef537a35c52e5c6ac8208822783b.jpg?v=1756714911",
        link: "https://wanaromah.com/products/floral-158",
    },
    {
        name: "Green Floral Garden",
        code: "floral-160",
        description: "Green florals, ivy, sea breeze",
        notes: {
            top: ["Green Florals", "Sea Breeze"],
            middle: ["Ivy", "Garden Flowers"],
            base: ["Green Musk", "Sandalwood", "Amber"],
        },
        occasions: [
            "Daytime wear",
            "Garden parties",
            "Fresh moments",
            "Nature walks",
        ],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/5f8780c20eff5ac8a3c5d4e769ca9bbe.jpg?v=1756714911",
        link: "https://wanaromah.com/products/floral-160",
    },
    {
        name: "Floral Elegance",
        code: "floral-157",
        description: "Mixed florals, elegance, sophistication",
        notes: {
            top: ["Mixed Florals", "Bergamot"],
            middle: ["Rose", "Jasmine"],
            base: ["Sandalwood", "Musk", "Amber"],
        },
        occasions: [
            "All occasions",
            "Office",
            "Evening wear",
            "Formal events",
        ],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "All seasons",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/c78ef2a9cc8afdd559c8e15aa43c3943.jpg?v=1756714911",
        link: "https://wanaromah.com/products/floral-157",
    },
    {
        name: "Floral Symphony",
        code: "floral-162",
        description: "Harmonious floral blend, symphony of flowers",
        notes: {
            top: ["Floral Blend", "Bergamot"],
            middle: ["Rose", "Jasmine", "Lily"],
            base: ["Sandalwood", "Musk", "Amber"],
        },
        occasions: [
            "Special occasions",
            "Evening wear",
            "Formal events",
            "Celebrations",
        ],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "All seasons",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/6da38171e3a6e6419c46400484f68c78.jpg?v=1756714910",
        link: "https://wanaromah.com/products/floral-195",
    },
    {
        name: "Floral Whisper",
        code: "floral-167",
        description: "Soft florals, whisper, delicate",
        notes: {
            top: ["Soft Florals", "Bergamot"],
            middle: ["Delicate Rose", "Jasmine"],
            base: ["White Musk", "Sandalwood", "Amber"],
        },
        occasions: [
            "Daytime wear",
            "Office",
            "Intimate moments",
            "Subtle elegance",
        ],
        longevity: "6-8 hours",
        sillage: "Light to Moderate",
        season: "All seasons",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/3581fb84acec0a0451cc66b1defe9acf.jpg?v=1756714911",
        link: "https://wanaromah.com/products/floral-190",
    },
    {
        name: "Floral Mystique",
        code: "floral-169",
        description: "Mysterious florals, mystique, enchanting",
        notes: {
            top: ["Mysterious Florals", "Bergamot"],
            middle: ["Enchanting Flowers", "Spices"],
            base: ["Sandalwood", "Musk", "Amber"],
        },
        occasions: [
            "Evening wear",
            "Special occasions",
            "Mysterious moments",
            "Enchanting events",
        ],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "All seasons",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/42f77282d2a94484c8a6272075ccbfc8.jpg?v=1756714910",
        link: "https://wanaromah.com/products/floral-171",
    },

    {
        name: "Raspberry Floral Charm",
        code: "sweet-136",
        description: "Juicy raspberry and floral tones with honey",
        notes: {
            top: ["Raspberry", "Neroli", "Amalfi Lemon"],
            middle: ["Jasmine", "Gardenia"],
            base: ["White Honey", "Patchouli", "Amber"],
        },
        occasions: ["Special Occasion"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-136_fbb17a80-fda1-490b-8be5-a663b28af887.jpg?v=1758281195",
        link: "https://wanaromah.com/products/sweet-136",
    },

    {
        name: "Fruity Playful Mix",
        code: "sweet-137",
        description: "Strawberry, peach, vanilla",
        notes: {
            top: ["Pear", "Red Berries"],
            middle: ["Gardenia", "Frangipani"],
            base: ["Patchouli", "Musk"],
        },
        occasions: ["Casual"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/e4896babf6d661083d25dc7ac1a8b13d.jpg?v=1756714911",
        link: "https://wanaromah.com/products/sweet-137",
    },
    {
        name: "Tropical Berry Coconut",
        code: "sweet-138",
        description: "Exotic blend of berries, coconut, and florals",
        notes: {
            top: ["Mango", "Blood Orange"],
            middle: ["Raspberry", "Star Apple", "Water Lily"],
            base: ["Musk", "Coconut", "Sandalwood"],
        },
        occasions: ["All"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-138_649eaba9-46c5-498b-8cce-19a7d08d3b16.jpg?v=1758281085",
        link: "https://wanaromah.com/products/sweet-138",
    },

    {
        name: "Berry Burst Joy",
        code: "sweet-139",
        description: "Mixed berries, sugar, musk",
        notes: {
            top: ["Amalfi Lemon", "Mandarin Orange"],
            middle: ["Nagarmotha", "Sea Notes"],
            base: ["Amber", "Patchouli"],
        },
        occasions: ["Formal"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/51c814671a6fad5176cc222906dbde71.jpg?v=1756714910",
        link: "https://wanaromah.com/products/sweet-139",
    }, {
        name: "Citrus Floral Essence",
        code: "sweet-142",
        description: "Zesty citrus blended with elegant florals",
        notes: {
            top: ["Lime", "Bergamot", "Blackcurrant", "Plum"],
            middle: ["Iris", "Rose", "Jasmine"],
            base: ["Musk", "Ambergris", "Cedar", "Sandalwood"],
        },
        occasions: ["Formal"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-142_f8409df6-0c0e-4e31-abc2-dec636a4b765.jpg?v=1758281085",
        link: "https://wanaromah.com/products/sweet-142",
    }
    , {
        name: "Citrus Blossom Joy",
        code: "sweet-145",
        description: "Bright mandarin and florals with a woody base",
        notes: {
            top: ["Mandarin Orange", "Bergamot"],
            middle: ["Jasmine"],
            base: ["Cypress", "Pine", "Laurels"],
        },
        occasions: ["Sports"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-145_9081dfa0-0eaa-48a2-8e26-cda1fc18cd4a.jpg?v=1758281085",
        link: "https://wanaromah.com/products/sweet-145",
    },

    {
        name: "Tropical Fruit Dream",
        code: "sweet-146",
        description: "Mango, pineapple, coconut",
        notes: {
            top: ["Saffron", "Raspberry", "Pineapple"],
            middle: ["Rose", "Davana"],
            base: ["Agarwood", "Nagarmotha", "Amber"],
        },
        occasions: ["Special Occasion"],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fd887a934c35fe6efcb899a23823c08b.jpg?v=1756714911",
        link: "https://wanaromah.com/products/sweet-146",
    },
    {
        name: "Berry Peony Glow",
        code: "sweet-148",
        description: "Vibrant berries blended with peony and florals",
        notes: {
            top: ["Passion Fruit", "Grapefruit", "Pineapple", "Strawberry"],
            middle: ["Peony", "Vanilla Orchid", "Red Berries", "Lily of the Valley"],
            base: ["Musk", "Cedarwood", "Oakmoss"],
        },
        occasions: ["Casual"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-148_a9481709-2ce1-4c30-adb3-73a11293348a.jpg?v=1758281086",
        link: "https://wanaromah.com/products/sweet-148",
    },


    {
        name: "Creamy Vanilla Dream",
        code: "sweet-140",
        description: "Madagascar vanilla, cream, caramel",
        notes: {
            top: ["Rose", "Jasmine", "Amber"],
            middle: ["Vanilla", "Tobacco"],
            base: ["Saffron", "Agarwood"],
        },
        occasions: ["Formal"],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/919218a719619f2007696dfd41c6f7cf.jpg?v=1756714911",
        link: "https://wanaromah.com/products/sweet-140",
    },
    {
        name: "Vanilla Silk",
        code: "sweet-141",
        description: "Vanilla, silk, white musk",
        notes: {
            top: ["Vanilla", "Sandalwood"],
            middle: ["Geranium", "Rose"],
            base: ["Amber", "Cedarwood", "Musk"],
        },
        occasions: ["Special Occasion"],
        longevity: "7-9 hours",
        sillage: "Moderate to Strong",
        season: "All Seasons",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/d21f708d91441b0f1b081f457486e55b.jpg?v=1756714911",
        link: "https://wanaromah.com/products/sweet-141",
    },
    {
        name: "Vanilla Bean Bliss",
        code: "sweet-151",
        description: "Vanilla bean, honey, sandalwood",
        notes: {
            top: ["Sugar", "Cocoa"],
            middle: ["Vanilla", "Dark Chocolate"],
            base: ["Amber", "Sugarcane"],
        },
        occasions: ["Special Occasion"],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/5e516d0a47dd0b364871ee58626d91cb.jpg?v=1756714911",
        link: "https://wanaromah.com/products/sweet-151",
    },
    {
        name: "Berry Musk Spark",
        code: "sweet-143",
        description: "Sweet berries with musky undertones",
        notes: {
            top: ["Lemon", "Blackcurrant", "Violet Leaf"],
            middle: ["Orange Blossom", "Rose"],
            base: ["Musk", "Sandalwood", "Civet"],
        },
        occasions: ["Sports"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "All",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-143_67a55ecc-7062-4578-9ad9-14141bcaf457.jpg?v=1758281086",
        link: "https://wanaromah.com/products/sweet-143",
    },

    {
        name: "Berry Musk Delight",
        code: "sweet-144",
        description: "Blackberry, raspberry, white musk",
        notes: {
            top: ["Floral Notes", "Vanilla", "Orchid"],
            middle: ["Musk", "Geranium", "Amber"],
            base: ["Amber", "Cedar", "Musk"],
        },
        occasions: ["All"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/27fea49eb423a7745ec1c998e09597d8.jpg?v=1756714911",
        link: "https://wanaromah.com/products/sweet-144",
    },
    {
        name: "Rose Vanilla Whisper",
        code: "sweet-149",
        description: "Gentle rose with sweet vanilla and woods",
        notes: {
            top: ["Cassis"],
            middle: ["Rose", "Freesia"],
            base: ["Vanilla", "Patchouli", "Woody Notes", "Ambroxan"],
        },
        occasions: ["All"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "All",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/sweet-149_e868d3a2-de72-46f8-8c7f-836065f9b678.jpg?v=1758281086",
        link: "https://wanaromah.com/products/sweet-149",
    },

    {
        name: "Mixed Berry Musk",
        code: "sweet-150",
        description: "Mixed berries, clean musk",
        notes: {
            top: ["Lavender", "Lemon", "Mint", "Basil"],
            middle: ["Caramel", "Cinnamon", "Strawberry"],
            base: ["Cedar", "Vetiver", "Amber", "Wood"],
        },
        occasions: ["All"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "All Seasons",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/2f7c1bd0949d5c07ef88e64d4e0572f5.jpg?v=1756714911",
        link: "https://wanaromah.com/products/sweet-150",
    },
    {
        name: "Berry Vanilla Musk",
        code: "sweet-152",
        description: "Berries, vanilla, soft musk",
        notes: {
            top: ["Big Strawberry"],
            middle: ["Raspberry", "Apple"],
            base: ["Sandalwood", "Strawberry"],
        },
        occasions: ["Sports"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/50c63c7c48d37404251e3511d71750f1.jpg?v=1756714911",
        link: "https://wanaromah.com/products/sweet-152",
    },

    {
        name: "Spiced Bergamot Glow",
        code: "fresh-117",
        description: "A warm fusion of bergamot and spice",
        notes: {
            top: ["Bergamot", "Lavender"],
            middle: ["Sichuan Pepper", "Anise", "Nutmeg"],
            base: ["Amber", "Vanilla"],
        },
        occasions: ["Casual"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Autumn/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fresh-117.jpg?v=1758281085",
        link: "https://wanaromah.com/products/fresh-117",
    },
    {
        name: "Green Tea Harmony",
        code: "fresh-118",
        description: "Refreshing green tea blended with citrus and musk",
        notes: {
            top: ["Bergamot", "Mandarin Orange"],
            middle: ["Green Tea", "Black Currant"],
            base: ["Musk", "Petitgrain", "Sandalwood", "Galbanum"],
        },
        occasions: ["Special Occasion"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fresh-118.jpg?v=1758281086",
        link: "https://wanaromah.com/products/fresh-118",
    },

    {
        name: "Bright Citrus Burst",
        code: "fresh-124",
        description: "Lemon, bergamot, grapefruit",
        notes: {
            top: ["Bergamot", "Lemon", "Lavender", "Verbena"],
            middle: [
                "Red Apple",
                "Geranium",
                "Rose",
                "Coumarin",
                "Oakmoss",
            ],
            base: ["Tonka Beans", "Sandalwood"],
        },
        occasions: ["Formal"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/5c222e5464dbf2adf2de2e9b67e79d9a.jpg?v=1756714911",
        link: "https://wanaromah.com/products/fresh-124",
    },
    {
        name: "Citrus Blossom Veil",
        code: "fresh-129",
        description: "Citrusy brightness balanced with soft florals",
        notes: {
            top: ["Jasmine", "Bergamot", "Musk"],
            middle: ["Vanilla", "Orange Blossom"],
            base: ["Ambergris", "Musk"],
        },
        occasions: ["Special Occasion"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fresh-129.jpg?v=1758281085",
        link: "https://wanaromah.com/products/fresh-129",
    },

    {
        name: "Citrus Sunshine",
        code: "fresh-130",
        description: "Orange, lime, citrus zest",
        notes: {
            top: ["Saffron", "Jasmine"],
            middle: ["Amber", "Ambergris"],
            base: ["Fir Resin", "Cedar"],
        },
        occasions: ["Sports"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/7a68d9546066ffb68b3d2665ac381409.jpg?v=1756714910",
        link: "https://wanaromah.com/products/fresh-130",
    }, {
        name: "Citrus Spice Fresh",
        code: "fresh-133",
        description: "Zesty citrus blended with aromatic spices",
        notes: {
            top: ["Lavender", "Lemon", "Bergamot", "Mandarin Orange"],
            middle: ["Sage", "Juniper Berries", "Basil", "Coriander"],
            base: ["Sandalwood", "Vetiver", "Musk", "Amber", "Rosewood"],
        },
        occasions: ["All"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fresh-133.jpg?v=1758281085",
        link: "https://wanaromah.com/products/fresh-133",
    },

    {
        name: "Sparkling Citrus",
        code: "fresh-134",
        description: "Sparkling lemon, yuzu, mint",
        notes: {
            top: ["Grapefruit", "Tangerine"],
            middle: ["Pineapple", "Cedar"],
            base: ["Amber", "Tonka Beans"],
        },
        occasions: ["Special Occasion"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/463f4915fc3a7bc410b195b5d425c708.jpg?v=1756714910",
        link: "https://wanaromah.com/products/fresh-134",
    },

    {
        name: "Citrus Tobacco Twist",
        code: "fresh-127",
        description: "A bold play of citrus, florals, and tobacco",
        notes: {
            top: ["Neroli", "Apple", "Lemon", "Bergamot"],
            middle: ["Rose", "Teakwood", "Patchouli"],
            base: ["Vanilla", "Musk", "Tobacco"],
        },
        occasions: ["Sports"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Autumn/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fresh-127.jpg?v=1758281086",
        link: "https://wanaromah.com/products/fresh-127",
    },

    {
        name: "Green Clean Breeze",
        code: "fresh-120",
        description: "Mint, eucalyptus, green tea",
        notes: {
            top: ["Bergamot", "Sea Notes", "Coriander"],
            middle: ["Lavender", "Rosemary", "Geranium", "Neroli"],
            base: ["Amber", "Musk", "Cedarwood", "Oakmoss"],
        },
        occasions: ["All"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/62262d9414fbbf36cbb7bcf039f2f24c.jpg?v=1756807855",
        link: "https://wanaromah.com/products/fresh-120",
    },
    {
        name: "Fresh Green Leaves",
        code: "fresh-125",
        description: "Green leaves, bamboo, dew",
        notes: {
            top: ["Sea Water", "Lavender", "Mint", "Coriander"],
            middle: ["Sandal", "Neroli", "Geranium", "Jasmine"],
            base: ["Musk", "Tobacco", "Oakmoss", "Cedar", "Amber"],
        },
        occasions: ["Sports"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/73d4d85ffc5d24c1d4ad76db69a85241.jpg?v=1756714911",
        link: "https://wanaromah.com/products/fresh-125",
    },
    {
        name: "Clean Green Air",
        code: "fresh-128",
        description: "Clean air, green grass, ozone",
        notes: {
            top: ["Musk", "Lime"],
            middle: ["Herbal Notes"],
            base: ["Amber", "Sandalwood", "Musk"],
        },
        occasions: ["Casual"],
        longevity: "6-8 hours",
        sillage: "Light to Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/16a45555b943a3de51991fb3245e42b9.jpg?v=1756714911",
        link: "https://wanaromah.com/products/fresh-128",
    },
    {
        name: "Aquatic Ocean Mist",
        code: "fresh-131",
        description: "Sea salt, marine accord, driftwood",
        notes: {
            top: ["Musk", "Lily", "Galbanum", "Ylang-Ylang"],
            middle: ["Musk", "Lily", "Rose"],
            base: [
                "Musk",
                "Iris",
                "Oakmoss",
                "Peach",
                "Amber",
                "Vanilla",
            ],
        },
        occasions: ["All"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/d21f708d91441b0f1b081f457486e55b.jpg?v=1756714911",
        link: "https://wanaromah.com/products/fresh-131",
    },
    {
        name: "Deep Ocean Breeze",
        code: "fresh-132",
        description: "Ocean breeze, seaweed, minerals",
        notes: {
            top: ["Lemon", "Mint", "Rosemary", "Bergamot", "Basil"],
            middle: ["Juniper", "Coriander", "Clove"],
            base: ["Oakmoss", "Musk", "Patchouli", "Amber", "Resin"],
        },
        occasions: ["Formal"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/ea3527c0047505a768231ed301fac3fa.jpg?v=1756714911",
        link: "https://wanaromah.com/products/fresh-132",
    },

    {
        name: "Clove Pepper Heat",
        code: "spicy-171",
        description: "Black pepper, clove, cinnamon",
        notes: {
            top: ["Bergamot", "Clove", "Lavender", "Lemon", "Basil"],
            middle: ["Musk", "Juniper", "Coriander", "Cinnamon"],
            base: [
                "Cedarwood",
                "Amber",
                "Vetiver",
                "Sandalwood",
                "Resins",
                "Oakmoss",
                "Patchouli",
            ],
        },
        occasions: ["All"],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/fb12b60a1bf48adcb7dfd5542c01a45f.jpg?v=1756714911",
        link: "https://wanaromah.com/products/spicy-171",
    }, {
        name: "Fiery Vetiver Spice",
        code: "spicy-172",
        description: "Vetiver with chilli heat and warm spices",
        notes: {
            top: ["Pepper", "Labdanum"],
            middle: ["Patchouli", "Rose", "Pepper"],
            base: ["Benzoin", "Amber", "Vanilla", "Pink Pepper"],
        },
        occasions: ["Special Occasion"],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-172_9a25ffa5-fd81-4f35-bdce-672e4289f953.jpg?v=1758281086",
        link: "https://wanaromah.com/products/spicy-172",
    },

    {
        name: "Peppery Spice Blend",
        code: "spicy-173",
        description: "Pink pepper, clove, nutmeg",
        notes: {
            top: ["Clove", "Violet Leaf", "Labdanum"],
            middle: ["Patchouli", "Pink Pepper", "Orange Blossom"],
            base: ["Benzoin", "Amber", "Vanilla", "Musk"],
        },
        occasions: ["Casual"],
        longevity: "7-9 hours",
        sillage: "Moderate to Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/9801bd49465d4b4d148ae47cc41e61a6.jpg?v=1756714910",
        link: "https://wanaromah.com/products/spicy-173",
    },
    {
        name: "Spicy Pepper Fire",
        code: "spicy-174",
        description: "Hot pepper, clove, cardamom",
        notes: {
            top: ["Nutmeg", "Pepper Berries"],
            middle: ["Saffron", "Patchouli", "Woody Notes"],
            base: ["Cumin", "Amber", "Juniper Berries", "Cedar"],
        },
        occasions: ["All"],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/912936aee3717776bfaee4fe8e0e7dd2.jpg?v=1756714911",
        link: "https://wanaromah.com/products/spicy-174",
    },
    {
        name: "Cedar Clove Spice",
        code: "spicy-177",
        description: "Spicy clove balanced with woody cedar",
        notes: {
            top: ["Bergamot", "Clove", "Lavender", "Lemon", "Basil"],
            middle: ["Musk", "Juniper", "Coriander", "Cinnamon"],
            base: ["Cedarwood", "Amber", "Vetiver", "Sandalwood", "Resins", "Oakmoss", "Patchouli"],
        },
        occasions: ["Special Occasion"],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-177_c22e889f-5a7a-445d-9131-8e7e6701dcad.jpg?v=1758281085",
        link: "https://wanaromah.com/products/spicy-177",
    },
    {
        name: "Woody Cardamom Heat",
        code: "spicy-175",
        description: "Warm cardamom and woods with a fruity spark",
        notes: {
            top: ["Pear", "Apple", "Grapefruit"],
            middle: ["Rose", "Pink Pepper", "Cardamom"],
            base: ["Cinnamon", "Sandalwood", "Musk"],
        },
        occasions: ["Casual"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Autumn/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-175_c01ed518-f810-4a78-b624-4bcf26a843f6.jpg?v=1758281085",
        link: "https://wanaromah.com/products/spicy-175",
    },
    {
        name: "Cedar Spiced Heat",
        code: "spicy-178",
        description: "Zesty pepper with warm woody cedar",
        notes: {
            top: ["Bergamot", "Pepper"],
            middle: ["Lavender", "Sichuan Pepper", "Anise", "Nutmeg"],
            base: ["Amber", "Cedar", "Labdanum"],
        },
        occasions: ["Sports"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Autumn/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-178_6f209d9f-36c6-415c-9d0b-30eb4937798d.jpg?v=1758281086",
        link: "https://wanaromah.com/products/spicy-178",
    },
    {
        name: "Woody Spice Blend",
        code: "spicy-180",
        description: "Cardamom, cedar, nutmeg",
        notes: {
            top: ["Lavender", "Amalfi Lemon", "Bergamot"],
            middle: ["Thyme", "Sage", "Pink Pepper", "Cinnamon"],
            base: ["Tobacco", "Vetiver", "Patchouli"],
        },
        occasions: ["Formal"],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/74ddc8f0ded24489aecbe13eb8a19d68.jpg?v=1756714911",
        link: "https://wanaromah.com/products/spicy-180",
    },
    {
        name: "Spiced Woods",
        code: "spicy-184",
        description: "Spiced woods, sandalwood, amber",
        notes: {
            top: ["Apple", "Lemon", "Plum", "Cinnamon"],
            middle: ["Cinnamon", "Mahogany", "Oakmoss"],
            base: ["Vanilla", "Sandalwood", "Vetiver", "Tobacco"],
        },
        occasions: ["Formal"],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/dfc2a5c42262f5428114f8928d36c696.jpg?v=1756714911",
        link: "https://wanaromah.com/products/spicy-184",
    },
    {
        name: "Leather Smoke Mystery",
        code: "spicy-179",
        description: "Smoky leather, tobacco, spices",
        notes: {
            top: ["Nutmeg Flower", "Cedar", "Chamomile", "Hawthorn"],
            middle: ["Nutmeg", "Sandalwood", "Honeysuckle"],
            base: ["Leather", "Tonka Beans", "Vetiver", "Patchouli"],
        },
        occasions: ["Casual"],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/caf0afb3b00ee373e8ad476204b2b8c3.jpg?v=1756714911",
        link: "https://wanaromah.com/products/spicy-179",
    },
    {
        name: "Smoky Leather Blend",
        code: "spicy-181",
        description: "Leather, smoke, dark spices",
        notes: {
            top: ["Basil", "Galbanum", "Nutmeg Flower", "Artemisia"],
            middle: [
                "Pine Tree Needles",
                "Nutmeg",
                "Patchouli",
                "Spices",
                "Vetiver",
            ],
            base: [
                "Leather",
                "Benzoin",
                "Coconut",
                "Tonka Beans",
                "Amber",
                "Vanilla",
                "Sandalwood",
            ],
        },
        occasions: ["Sports"],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/004f82da822a34ce2bc697ba404dab79.jpg?v=1756714911",
        link: "https://wanaromah.com/products/spicy-181",
    },
    {
        name: "Patchouli Pepper Blend",
        code: "spicy-183",
        description: "Patchouli layered with pepper and woody musk",
        notes: {
            top: ["Nutmeg", "Pink Pepper", "Bergamot"],
            middle: ["Patchouli", "Cedar", "Sandalwood"],
            base: ["Civette", "Amber", "Musk", "Oakmoss"],
        },
        occasions: ["All"],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Autumn/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-183_c46e7814-e3c5-45d3-9e5f-7937aafc3a86.jpg?v=1758281086",
        link: "https://wanaromah.com/products/spicy-183",
    },

    {
        name: "Chilli Citrus Zest",
        code: "spicy-176",
        description: "Bright citrus infused with chilli and spice",
        notes: {
            top: ["Chilli", "Bergamot"],
            middle: ["Ginger", "Vetiver"],
            base: ["Vetiver", "Cypress", "Laurel", "Chilli Berry"],
        },
        occasions: ["Sports"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-176_3b249775-6edc-4ec2-9f5e-6d01ede8f5c5.jpg?v=1758281086",
        link: "https://wanaromah.com/products/spicy-176",
    },
    {
        name: "Basil Musk Fusion",
        code: "spicy-182",
        description: "Aromatic basil blended with spiced musk",
        notes: {
            top: ["Lavender", "Anise", "Basil", "Lemon"],
            middle: ["Ylang-Ylang", "Geranium", "Nutmeg"],
            base: ["Coumarin", "Musk", "Sandalwood", "Tonka Beans", "Vetiver", "Patchouli", "Vanilla"],
        },
        occasions: ["Formal"],
        longevity: "8-10 hours",
        sillage: "Strong",
        season: "Autumn/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-182_7dab2d10-d734-4908-bc94-1cb8a8e209d3.jpg?v=1758281085",
        link: "https://wanaromah.com/products/spicy-182",
    },
    {
        name: "Ginger Smoke Incense",
        code: "spicy-185",
        description: "Zesty ginger with smoky incense and spice",
        notes: {
            top: ["Ginger", "Lemon", "Mint"],
            middle: ["Nutmeg", "Pink Pepper", "Ginger"],
            base: ["Patchouli", "Incense", "Cedar"],
        },
        occasions: ["Casual"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Fall/Winter",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/spicy-185_3ad4eff9-e7b0-44ac-9584-619ac856f556.jpg?v=1758281086",
        link: "https://wanaromah.com/products/spicy-185",
    },


    {
        name: "Fresh Spice Garden",
        code: "spicy-186",
        description: "Basil, mint, pink pepper",
        notes: {
            top: ["Peppermint", "Bergamot"],
            middle: ["Mint", "Vetiver", "Lemon"],
            base: ["Cinnamon", "Musk", "Sandalwood"],
        },
        occasions: ["Sports"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/4022d4c054286d625305440962a03dec.jpg?v=1756714911",
        link: "https://wanaromah.com/products/spicy-186",
    },
    {
        name: "Minty Spice Blend",
        code: "spicy-187",
        description: "Mint, basil, green cardamom",
        notes: {
            top: ["Peppermint", "Anise", "Basil"],
            middle: ["Lavender", "Bergamot"],
            base: ["Sandalwood", "Vanilla", "Musk"],
        },
        occasions: ["Special Occasion"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "Spring/Summer",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/bfbe3520e7b297edc8069765d3a4ef43.jpg?v=1756807854",
        link: "https://wanaromah.com/products/spicy-187",
    },
    {
        name: "Herbal Spice Fresh",
        code: "spicy-188",
        description: "Fresh herbs, spices, mint",
        notes: {
            top: ["Mint", "Lemon", "Rosemary"],
            middle: ["Musk", "Cinnamon", "Juniper"],
            base: ["Musk"],
        },
        occasions: ["All"],
        longevity: "6-8 hours",
        sillage: "Moderate",
        season: "All Seasons",
        img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/8802a457a91d87141e17cb3f6016eaea.jpg?v=1756810438",
        link: "https://wanaromah.com/products/spicy-188",
    },
            {
                name: "Mullai",
                code: "mullai",
                description: "Sweet floral",
                benefit: "REDUCE STRESS",
                notes: {
                    top: ["Sweet Jasmine", "White Flowers"],
                    middle: ["Mullai Blossoms", "Green Leaves"],
                    base: ["Soft Musk", "Woody Notes"]
                },
                occasions: ["Meditation", "Relaxation", "Evening wear", "Self-care"],
                longevity: "4-6 hours",
                sillage: "Soft",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/mullai.webp?v=1759753704"
            },
            {
                name: "Thazhampoo",
                code: "thazhampoo",
                description: "Spicy floral",
                benefit: "GOOD FOR SPIRITUALITY",
                notes: {
                    top: ["Spiced Florals", "Clove"],
                    middle: ["Magnolia", "Temple Flowers"],
                    base: ["Incense", "Sandalwood", "Amber"]
                },
                occasions: ["Meditation", "Prayer", "Spiritual practices", "Temple visits"],
                longevity: "5-7 hours",
                sillage: "Moderate",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Thazhampoo.jpg?v=1759753705"
            },
            {
                name: "Pitchipoo",
                code: "pitchipoo",
                description: "Floral & musky",
                benefit: "ENERGIZES THE MOOD",
                notes: {
                    top: ["Fresh Florals", "Citrus"],
                    middle: ["Jasmine", "White Flowers"],
                    base: ["Musk", "Amber", "Soft Woods"]
                },
                occasions: ["Morning wear", "Work", "Active days", "Social gatherings"],
                longevity: "4-6 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Pitchipoo.webp?v=1759753704"
            },
            {
                name: "Marikolundhu",
                code: "marikolundhu",
                description: "Citrus & floral",
                benefit: "IMPROVES SLEEP",
                notes: {
                    top: ["Bergamot", "Lemon", "Orange Blossom"],
                    middle: ["Lavender", "Chamomile"],
                    base: ["Soft Musk", "Vanilla", "Sandalwood"]
                },
                occasions: ["Bedtime", "Evening relaxation", "Stress relief", "Home wear"],
                longevity: "4-6 hours",
                sillage: "Soft",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Marikolundhu_0b114d36-1505-49ab-8f43-aeffd59e12f0.png?v=1759753706"
            },
            {
                name: "Mogra",
                code: "mogra",
                description: "Green floral",
                benefit: "CALMS THE MIND",
                notes: {
                    top: ["Green Leaves", "Fresh Jasmine"],
                    middle: ["Mogra Flowers", "White Florals"],
                    base: ["Soft Musk", "Cedarwood"]
                },
                occasions: ["Meditation", "Yoga", "Evening wear", "Relaxation"],
                longevity: "5-7 hours",
                sillage: "Soft to Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Mogra.jpg?v=1759753704"
            },
            {
                name: "Sampangi",
                code: "sampangi",
                description: "Fruity & floral",
                benefit: "REDUCE TENSION",
                notes: {
                    top: ["Peach", "Apricot", "Citrus"],
                    middle: ["Champaca", "Orange Blossom"],
                    base: ["Sandalwood", "Musk", "Vanilla"]
                },
                occasions: ["Daytime wear", "Stress relief", "Social events", "Casual outings"],
                longevity: "5-7 hours",
                sillage: "Moderate",
                season: "Spring/Summer",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Sampangi.jpg?v=1759753703"
            },
            {
                name: "Tube Rose",
                code: "tube rose",
                description: "Earthy floral",
                benefit: "AIDS SLEEP",
                notes: {
                    top: ["Green Notes", "Bergamot"],
                    middle: ["Tuberose", "Jasmine"],
                    base: ["Earthy Musk", "Sandalwood", "Amber"]
                },
                occasions: ["Bedtime", "Evening relaxation", "Meditation", "Calm moments"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Tube_Rose.jpg?v=1759753704"
            },
            {
                name: "Night Queen",
                code: "night queen",
                description: "Floral sweet",
                benefit: "ANXIETY RELIEVER",
                notes: {
                    top: ["Sweet Florals", "Honeysuckle"],
                    middle: ["Night Blooming Jasmine", "Gardenia"],
                    base: ["Vanilla", "Musk", "Amber"]
                },
                occasions: ["Evening wear", "Stress relief", "Romantic evenings", "Relaxation"],
                longevity: "5-7 hours",
                sillage: "Moderate",
                season: "Summer/Fall",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Night_Queen.jpg?v=1759753704"
            },
            {
                name: "Ylang Ylang",
                code: "ylang ylang",
                description: "Fruity & spice",
                benefit: "AIDS SLEEP",
                notes: {
                    top: ["Banana", "Neroli", "Bergamot"],
                    middle: ["Ylang Ylang", "Jasmine", "Spices"],
                    base: ["Vanilla", "Sandalwood", "Musk"]
                },
                occasions: ["Bedtime", "Meditation", "Evening wear", "Spa days"],
                longevity: "6-8 hours",
                sillage: "Moderate to Strong",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Ylang_Ylang.jpg?v=1759753704"
            },
            {
                name: "Pahadi",
                code: "pahadi",
                description: "Floral & earthy",
                benefit: "CALMING",
                notes: {
                    top: ["Mountain Flowers", "Fresh Air"],
                    middle: ["Wild Herbs", "Lavender"],
                    base: ["Earth", "Moss", "Cedarwood"]
                },
                occasions: ["Meditation", "Yoga", "Nature walks", "Stress relief"],
                longevity: "4-6 hours",
                sillage: "Soft",
                season: "Spring/Fall",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Pahadi.jpg?v=1759753703"
            },
            {
                name: "Rajinigantha",
                code: "rajinigantha",
                description: "Floral & vetiver",
                benefit: "RELAXATION",
                notes: {
                    top: ["White Flowers", "Green Leaves"],
                    middle: ["Tuberose", "Jasmine"],
                    base: ["Vetiver", "Sandalwood", "Musk"]
                },
                occasions: ["Evening wear", "Meditation", "Stress relief", "Calm moments"],
                longevity: "6-8 hours",
                sillage: "Moderate",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Rajinigantha.jpg?v=1759753704"
            },
            {
                name: "Rose",
                code: "rose",
                description: "Floral & warm spice",
                benefit: "IMPROVES BRAIN HEALTH",
                notes: {
                    top: ["Rose Petals", "Bergamot"],
                    middle: ["Bulgarian Rose", "Geranium", "Cinnamon"],
                    base: ["Amber", "Sandalwood", "Musk"]
                },
                occasions: ["Daytime wear", "Focus work", "Study sessions", "All occasions"],
                longevity: "5-7 hours",
                sillage: "Moderate",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/rose.jpg?v=1759753704"
            },
            {
                name: "Jawwad",
                code: "jawwad",
                description: "Civet & amber",
                notes: {
                    top: ["Saffron", "Rose"],
                    middle: ["Civet", "Amber"],
                    base: ["Benzoin", "Musk", "Agarwood"]
                },
                occasions: ["Special occasions", "Evening wear", "Cultural events", "Celebrations"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Jawwad.jpg?v=1759753725"
            },
            {
                name: "Jawwad Amrut",
                code: "jawwad amrut",
                description: "Civet, amber & honey",
                notes: {
                    top: ["Honey", "Nutmeg", "Saffron"],
                    middle: ["Civet", "Patchouli", "Rose"],
                    base: ["Amber", "Labdanum", "Benzoin"]
                },
                occasions: ["Special occasions", "Evening wear", "Weddings", "Formal events"],
                longevity: "10-12 hours",
                sillage: "Very Strong",
                season: "Fall/Winter",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Amrut.jpg?v=1759753724"
            },
            {
                name: "Majmua",
                code: "majmua",
                description: "Rose, amber & wood",
                notes: {
                    top: ["Saffron", "White Rose", "Bergamot"],
                    middle: ["Amber", "Bulgarian Rose", "Patchouli"],
                    base: ["Sandalwood", "Mixed Woods", "Vetiver"]
                },
                occasions: ["Special occasions", "Prayer", "Cultural events", "Evening wear"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/067b0e2fdb238975d6567015ae713ec0.jpg?v=1756711135"
            },
            {
                name: "Jannat Ul Firdaus",
                code: "jannat ul firdaus",
                description: "Rose, herbal & spice",
                notes: {
                    top: ["Herbal Notes", "Grass", "Citrus"],
                    middle: ["Rose", "Cinnamon", "Lotus", "Tea"],
                    base: ["Woody Notes", "Jasmine", "Musk"]
                },
                occasions: ["Special occasions", "Prayer", "Spiritual events", "Evening wear"],
                longevity: "8-10 hours",
                sillage: "Strong",
                season: "All seasons",
                img: "https://cdn.shopify.com/s/files/1/0855/2788/8154/files/Jannat_Ul_Firdaus.jpg?v=1759753723"
            }
        
        ];
